import { fromJS, OrderedMap} from 'immutable';
import { sortGroupEle } from './helpers/utilityMethods';
import { changeTextComplete, updateTextComplete, uploadBulkUpdateComplete, uploadBulkDeleteComplete, updateGroupTextComplete, addSceneComplete, moveSceneComplete,addObjComplete, changeAnimationTypeComplete, moveUpdateComplete, duplicateSceneComplete, removeSceneComplete, addSceneTransitionComplete, changeActionComplete, changeExpressionComplete, changeVideoVolumeComplete, changeBgComplete, deleteBgComplete,  applyFilterComplete, updateSvgColorComplete, updateSvgThemeComplete, flipItemComplete, cropImageComplete, cropBgComplete, bgColorSelectionComplete, bgGradientColorsComplete, updateBgColorComplete, updateBgGradientComplete, changeSceneDurationComplete, setSelectedItemsComplete, setSelectedSceneComplete, deleteItemComplete, setZIndexComplete, groupObjectsComplete, ungroupObjectsComplete, updateTimelineDragChangeComplete, pasteItemsComplete, pasteScenesComplete , updateBgComplete, updateProjectComplete, updateObjectComplete, setSelectedScene, addPrebuiltComplete, loadCommonPopup, changeSceneTransColorComplete, updateSceneComplete, manageToast,applyEnterEffectComplete, applyAllTransitionComplete , addLinkToTextComplete,setWorkspaceItemsOrderComplete, setAnimateValuesComplete , setAnimateValueComplete, setLabelValues , setNewActionComplete,addLinkToObjComplete} from './actions/index';
import config from './config/app.json';

var pushActions = [];

const sceneDuration = config["SCENE"]["duration"];
export const autosaveMiddleware = store => next => action =>
{
  var state = store.getState();
  var projectid = state.localStore.get("projectid");
  var socketid = state.localStore.get("socketid");
  var projectUsr = state.localStore.get("projectUsr");
  var userId = state.localStore.get("userId");
  var projectUsrImg = state.localStore.get("projectUsrImg");
  if (state.localStore.get('isPlay') || state.localStore.get('isPlayAll'))
  {
    if (action.type.indexOf("COMPLETE") > -1)
    {
      pushActions.push(action)
      return;
    }
  }
  else
  {
    if (pushActions.length > 0)
    {
      var pushingArr = pushActions.slice();
      pushActions = []
      store.dispatch({ type: "BATCH_ACTIONS", actions: pushingArr })
    }
  }
  
  // if((action.type !== "SAVE_START" && action.type !== "SAVE_DONE"))
  // {
  //   if (action.type.indexOf("COMPLETE") > -1 && action.type !== "LOAD_LIBRARY_COMPLETE" && action.type !== "LOAD_CATEGORY_COMPLETE" && action.type !== "SET_NEW_ACTION_COMPLETE" && action.type !== "ADD_PREBUILT_COMPLETE")
  //   {
  //     store.dispatch({ type: "SAVE_DONE" })
  //   }
  // }

  if(action.selectedScene !== undefined && action.socket !== undefined && state.localStore.get('selectedScene') !== action.selectedScene){
    store.dispatch(setSelectedScene(action.selectedScene, state.project.getIn(["scenes", action.selectedScene, "startTime" ]), [action.selectedScene], action.socket));
  }
  else if(action.data !== undefined && action.data.selectedScene !== undefined && state.localStore.get('selectedScene') !== action.data.selectedScene){
    if(action.socket !== undefined)
      store.dispatch(setSelectedScene(action.data.selectedScene, state.project.getIn(["scenes", action.data.selectedScene, "startTime" ]), [action.selectedScene], action.socket));
    else if(action.data.socket !== undefined)
      store.dispatch(setSelectedScene(action.data.selectedScene, state.project.getIn(["scenes", action.data.selectedScene, "startTime" ]), [action.selectedScene], action.data.socket));
  }
  
  if (action.type === "ADD_SCENE" || action.type === "ADD_OBJECT"|| action.type === "MOVE_UPDATE" || action.type === "ROTATION_UPDATE" || action.type === "RESIZE_UPDATE" || action.type === "DUPLICATE_SCENE" || action.type === "REMOVE_SCENE" || action.type === "ADD_SCENE_TRANSITION" || action.type === "CHANGE_ACTION" || action.type === "CHANGE_EXPRESSION" || action.type === "DROP_BG" || action.type === "CHANGE_BG" || action.type === "DELETE_BG" || action.type === "APPLY_FILTER" || action.type === "CHANGE_OBJECT_END_TIME" || action.type === "UPDATE_VIDEO_DATA" || action.type === "UPDATE_SVGCOLOR" || action.type === "FLIP_ITEM" || action.type === "CROP_IMAGE" || action.type === "CROP_BG" || action.type === "BG_COLOR_SELECTION" || action.type === "BG_GRADIENT_COLORS" || action.type === "CHANGE_BG_THUMB_VALUE" || action.type === "CHANGE_TEXT" || action.type === "SET_KEYFRAMES" || action.type === "UPDATE_GROUP_OBJECTS" || action.type === "UPDATE_GROUP_TEXT" || action.type === "DELETE_ITEM" || action.type === "SET_Z_INDEX" || action.type === "GROUP_OBJECTS" || action.type === "UNGROUP_OBJECTS" || action.type === "UPDATE_TEXT" || action.type === "UPDATE_TIMELINE_DRAG" || action.type === "PASTE_ITEMS" || action.type === "MOVE_SCENE" || action.type === "UPDATE_OBJECT" || action.type==='APPLY_ENTER_EFFECT' || action.type==='SET_ANIMATE_VALUE' || action.type==='SET_WORKSPACE_ITEMS_ORDER' || action.type==='ADD_LINK_TO_TEXT' || action.type === 'APPLY_ALL_TRANSITION' || action.type === 'ADD_PREBUILT')
  {
    store.dispatch({ type: "SAVE_START" });
    store.dispatch(setNewActionComplete(true));
  }

  if (action.type === "ADD_SCENE")
  {
    var currentSlide = state.project.getIn(["scenes", action.data.selectedScene]);
    var bgColors = currentSlide.getIn(["workspaceBG", "color"]), color = ["#FFFFFF"];
    if(bgColors !== undefined && bgColors.size > 0)
    {
      color = bgColors;
    }
    var totalDuration = 0;
    for (var i = 0; i < action.data.selectedScene+1; i++) {
      totalDuration += state.project.getIn(['scenes', i, 'duration']);
    }
    var slideIndex = action.data.selectedScene + 1;
    var newslide = {
      "id" : Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString(),
      "duration": sceneDuration,
      "workspaceChildren": {},
      "workspaceItems": {},
      "workspaceBG": {
        "color":  color,
        "src": "",
        "x": 0,
        "y": 0,
        "width": 1,
        "height": 1,
        "type": "",
        "videoStart":0,
        "videoEnd":10,
      },
      "startTime": totalDuration,
      "transEffect": "NoTransition"
    }
    if(action.data.slide !== undefined){
      newslide = action.data.slide.toJS();
    }
    store.dispatch(addSceneComplete(slideIndex, newslide,action.socket.id,action.socket.id));
    action.socket.emit('addScene', slideIndex, newslide, userId);  
  }

  if (action.type === "MOVE_SCENE")
  {
  
    action.playheadVal = state.project.getIn(["scenes", action.newIndex, "startTime"]);
    store.dispatch(moveSceneComplete(projectid, action.newIndex, action.oldIndex, action.socket.id, action.socket.id));
    action.socket.emit('moveScene', action.newIndex, action.oldIndex, userId);    
  }

  if (action.type === "ADD_OBJECT")
  {
    var selectedScene = action.data.selectedScene;
    
    let enterStart = 0,
      exitEnd = state.project.getIn(['scenes', selectedScene, 'duration']);
    var enterEnd = 0, exitStart = 0, enterEffectName = "no_Effect",flipPosition = 0, childIds = [];
    let animType='On Load',animIndex=0;
    if (exitEnd - enterStart <= 1 && exitEnd >= 2)
      enterStart = exitEnd - 2;

    if (enterStart === exitEnd)
      enterStart = 0;

    var workspaceObjects = {}, childObjects = {};
    var workspaceIds = [], workspaceChildIds = [], workspaceData = [], workspaceChildData = [];
    if (action.data.type !== "TXTGRP") {
      var workspaceItems = state.project.getIn(["scenes", selectedScene, "workspaceItems"]);
      let maxIndex = 0;
      if (workspaceItems.size > 0)
      {
        let maxItem = workspaceItems.maxBy(x => x.get("index"));
        maxIndex = maxItem.get("index") + 1;
        animIndex = maxItem.get("index") + 1;
      }
      var uniqueId = action.data.item_id;
      if(action.data.flipPosition !== undefined)
        flipPosition = action.data.flipPosition;
      
      if ((action.data.swapDetails !== null && !action.data.emptySwap) || action.data.undoSwap)
      {
        uniqueId = state.localStore.getIn(["selectedItems", 0])||action.data.swapDetails.id;
        enterEnd = action.data.enterEnd;enterEffectName = action.data.enterEffectName;
        enterStart = action.data.enterStart;flipPosition = action.data.flipPosition;
        maxIndex=action.data.index;
      }
     
      let objectData = {
        "index": maxIndex,
        "assetId": action.data.assetId,
        "width": action.data.width,
        "height": action.data.height,
        "x": action.data.x,
        "y": action.data.y,
        "angle": action.data.angle,
        "type": action.data.type,
        "src": action.data.src,
        "thumb": action.data.thumb,
        "flipPosition": flipPosition,
        "enterStart": enterStart,
        "enterEffectName": enterEffectName,
        "enterEnd": enterEnd,
        "opacity": 1,
        "displaysizes": action.data.displaysizes,
        "animIndex":animIndex,
        "animType":animType,
  
      }
      if(action.data.swapDetails !== null && !action.data.emptySwap){
        objectData.animType=action.data.swapDetails.animType;
        objectData.animIndex=action.data.swapDetails.animIndex;
        objectData.index=action.data.swapDetails.index;
      }

      if(action.data.isBlob !== undefined){
        objectData['isBlob'] = action.data.isBlob
      }
      if(action.data.colors){
        objectData.colors = action.data.colors;
        objectData.defaultColor = action.data.defaultColor;
      }

      if(action.data.subType !== undefined && action.data.subType !== null){
        objectData.subType = action.data.subType;
      }

      if(action.data.emptySwap)
        objectData.index=action.data.index;

      if(action.data.type === "PROP"){
        objectData.repeatLoop = action.data.repeatLoop;
        objectData.colors = action.data.colors;
        objectData.defaultColor =  action.data.colors;
        objectData.isRepeated =  action.data.isRepeated;
        objectData.isAnimated =  action.data.isAnimated;
        objectData.animsrc = action.data.animsrc;
        objectData.animdata = action.data.animdata;
      }
      else if(action.data.type === "CHR"){
        objectData.charId = action.data.charId;
        objectData.colors = action.data.colors;
        objectData.defaultColor =  action.data.colors;
        objectData.animsrc = action.data.animsrc;
        objectData.isRepeated =  action.data.isRepeated;
        objectData.isAnimated =  action.data.isAnimated;
        objectData.voiceOver  =  {"audio": {},"data": ""};
        objectData.parts = action.data.parts;
        objectData.pose = "front";
        objectData.expression = "happy";
        objectData.animdata = action.data.animdata;
        objectData.genderType = action.data.genderType;
        objectData.voiceOverData = action.data.voiceOverData
      }
      else if(action.data.type === "SHAPE"){
        objectData.groupBounds = action.data.groupBounds;
        objectData.pathData = action.data.pathData;
        objectData.isVertical = action.data.isVertical;
        objectData.isHorizontal = action.data.isHorizontal;
        objectData.scaleType = action.data.scaleType;
        objectData.textData = action.data.textData;
        objectData.colors = action.data.colors;
        objectData.defaultColor =  action.data.colors;
        objectData.widthRatio = action.data.widthRatio;
        objectData.heightRatio = action.data.heightRatio;
        objectData.xRatio = action.data.xRatio;
        objectData.yRatio = action.data.yRatio;
        objectData.maxWidthRatio = action.data.widthRatio;
        objectData.maxHeightRatio = action.data.heightRatio;
        objectData.minXRatio = action.data.xRatio;
        objectData.minYRatio = action.data.yRatio;

        if(action.data.subType === "CSTMPTH")
          objectData.path = action.data.path;
      }
      else if(action.data.type === "TEXT"){
        objectData.textData = action.data.textData;
      }

      if(action.data.pose !== undefined)
        objectData.pose = action.data.pose;

      if(action.data.opacity !== undefined)
        objectData.opacity = action.data.opacity;

      if(action.data.expression !== undefined)
        objectData.expression = action.data.expression;
      
      if(action.data.sizes !== undefined)
        objectData.sizes = action.data.sizes;

      if(action.data.sourceType !== undefined)
        objectData.sourceType = action.data.sourceType;
      
      if(action.data.expFlag !== undefined)
        objectData.expFlag = action.data.expFlag;
      if(action.data.mouthAction !== undefined)
        objectData.mouthAction = action.data.mouthAction;
      
      if (action.data.filter)
        objectData.filter = action.data.filter;
      if (action.data.voiceOver)
        objectData.voiceOver = action.data.voiceOver;
    
      workspaceIds.push(uniqueId);
      workspaceData.push(objectData);
    }else{
      var addedIds = [], key;
      childIds = [];
      let maxIndex = 0 ;
      for (key in action.data.items.workspaceChildren)
      {
        if (action.data.items.workspaceChildren.hasOwnProperty(key))
        {
          action.data.items.workspaceChildren[key]['animType']='On Click';
          action.data.items.workspaceChildren[key]['animIndex'] = maxIndex++;
          childObjects[key] = action.data.items.workspaceChildren[key];
          childIds.push(key);
          workspaceChildData.push(action.data.items.workspaceChildren[key]);
          workspaceChildIds.push(key);
        }
      }

      for (key in action.data.items.workspaceItems)
      {
        if (action.data.items.workspaceItems.hasOwnProperty(key))
        {
          if(action.data.items.workspaceItems[key]['subType']==='CSTMPTH' ||
          action.data.items.workspaceItems[key]['subType']=== 'DTXT'){
          action.data.items.workspaceItems[key]['animType'] = 'On Click';
          }
          workspaceObjects[key] = action.data.items.workspaceItems[key];
          workspaceObjects[key]["groupChildren"] = childIds;

          workspaceIds.push(key);
          workspaceData.push(workspaceObjects[key]);
        }
      }
    }
    
    action.sceneDuration  = state.project.getIn(["scenes", state.localStore.get("selectedScene"), "duration"]);
    action.socket.emit('addObject', selectedScene, workspaceIds, workspaceData, workspaceChildIds, workspaceChildData, userId);     
    store.dispatch(addObjComplete(selectedScene, workspaceIds, workspaceData, workspaceChildIds, workspaceChildData, action.socket.id, action.socket.id));
  } 

  if (action.type === "CHANGE_ANIMATION_TYPE")
    {
      store.dispatch(changeAnimationTypeComplete(action.selectedScene, action.itemId, action.value, action.socket.id, action.socket.id));

        action.socket.emit('changeAnimationType', action.selectedScene, action.itemId, action.value, userId)        
    }

  if (action.type === "MOVE_UPDATE")
  {
    var selectedScene = action.data.selectedScene;
    var currentContainer = action.data.currentContainer;
    if(currentContainer === undefined)
      currentContainer = "workspaceItems";
    var getAllItems = state.project.getIn(["scenes", selectedScene, currentContainer]);

    var workspaceItems = fromJS({});
    var workspaceChildren = fromJS({});

      action.data.items.entrySeq().forEach(([key, item]) =>
      {
        if(item.get('x') !== undefined && item.get('y') !== undefined)
          workspaceItems = workspaceItems.set(key, fromJS({ x: item.get('x'), y: item.get('y') }));
        let item_to_merge = getAllItems.get(key);
        let dX = item.get('x') - item_to_merge.get("x"), dY = item.get('y') - item_to_merge.get("y");

        if (item.get("type") === "GROUP")
        {
          let item_to_merge = getAllItems.get(key);
          let dX = item.get('x') - item_to_merge.get("x"), dY = item.get('y') - item_to_merge.get("y");
          var groupItems = state.project.getIn(["scenes", selectedScene, "workspaceChildren"]);
          item.get("groupChildren").entrySeq().forEach(([childKey, itemId]) =>
          {
            let child = groupItems.get(itemId);
            let childToUpdate = { x: child.get("x") + dX, y: child.get("y") + dY };
            workspaceChildren = workspaceChildren.set(itemId, fromJS(childToUpdate));
          })
        }
      });
    store.dispatch(moveUpdateComplete(selectedScene, workspaceItems, workspaceChildren, currentContainer, action.socket.id, action.socket.id))
    action.socket.emit('moveUpdate', selectedScene, workspaceItems, workspaceChildren, currentContainer, userId);    
  }

  if (action.type === "ROTATION_UPDATE")
  {
    selectedScene = action.data.selectedScene;
    currentContainer = action.data.currentContainer;
    if(currentContainer === undefined)
      currentContainer = "workspaceItems";
    getAllItems = state.project.getIn(["scenes", selectedScene, currentContainer]);
    var groupItems = state.project.getIn(["scenes", selectedScene, "workspaceChildren"]);
    var workspaceItems = fromJS({});
    var workspaceChildren = fromJS({});

      action.data.items.entrySeq().forEach(([key, item]) =>
      {
        workspaceItems = workspaceItems.set(key, fromJS({ x: item.get('x'), y: item.get('y'), angle: item.get('angle') }));

        let item_to_merge = getAllItems.get(key);
        let dX = item.get('x') - item_to_merge.get("x"), dY = item.get('y') - item_to_merge.get("y"), dA = item.get('angle') - item_to_merge.get("angle");

       
        if (item.get("type") === "TXTOVLY" || item.get("type") === "GROUP")
        {
          item.get("groupChildren").entrySeq().forEach(([childKey, itemId]) =>
          {
            let child = groupItems.get(itemId);

            var childToUpdate = { x: child.get("x") + dX, y: child.get("y") + dY, angle : child.get("angle")};

            workspaceChildren = workspaceChildren.set(itemId, fromJS(childToUpdate));
          })
        }
      });
   
    store.dispatch(moveUpdateComplete(selectedScene, workspaceItems, workspaceChildren, currentContainer, action.socket.id, action.socket.id))
    action.socket.emit('moveUpdate', selectedScene, workspaceItems, workspaceChildren, currentContainer, userId)    
  }

  if (action.type === "RESIZE_UPDATE")
  {
    
    selectedScene = action.data.selectedScene;
    currentContainer = action.data.currentContainer;
    if(currentContainer === undefined)
      currentContainer = "workspaceItems";
    getAllItems = state.project.getIn(["scenes", selectedScene, currentContainer]);

    var workspaceItems = fromJS({});
    var workspaceChildren = fromJS({});

      action.data.items.entrySeq().forEach(([key, item]) =>
      {
        workspaceItems = workspaceItems.set(key, fromJS({ x: item.get('x'), y: item.get('y'), width: item.get('width'), height: item.get('height') }));
        var item_to_merge = getAllItems.get(key);

        if (item.get("type") === "TEXT" || item.get("type") === "SHAPE")
        {
          let isFixedWidth = item_to_merge.getIn(["textData", "formats", "others", "isFixedWidth"]);
          if (!isFixedWidth)
            item_to_merge = item_to_merge.setIn(["textData", "formats", "others", "isFixedWidth"], true);
          item_to_merge = item_to_merge.setIn(["textData", "formats", "containerStyle", "fontSize"], item.getIn(["textData", "formats", "containerStyle", "fontSize"]));
          item_to_merge = item_to_merge.setIn(["textData", "splittedText"], item.getIn(["textData", "splittedText"]));
         
          workspaceItems = workspaceItems.setIn([key, "textData"], item_to_merge.get("textData"));
        }

        if (item.get("type") === "SHAPE")
        {
          workspaceItems = workspaceItems.setIn([key, "groupBounds"], item.get("groupBounds"));
          if(item.get("pathData") !== undefined)
            workspaceItems = workspaceItems.setIn([key, "pathData"], item.get("pathData"));
          if(item.get("path") !== undefined)
            workspaceItems = workspaceItems.setIn([key, "path"], item.get("path"));
        }

        if(item.get("type") === "TEXT" && item.get("subType") === "BANNER"){
          if(item.get("pathData") !== undefined)
            workspaceItems = workspaceItems.setIn([key, "pathData"], item.get("pathData"));
          if(item.get("path") !== undefined)
            workspaceItems = workspaceItems.setIn([key, "path"], item.get("path"));
          if(item.get("xRatio") !== undefined)
            workspaceItems = workspaceItems.setIn([key, "xRatio"], item.get("xRatio"));
          if(item.get("yRatio") !== undefined)
            workspaceItems = workspaceItems.setIn([key, "yRatio"], item.get("yRatio"));
          if(item.get("widthRatio") !== undefined)
            workspaceItems = workspaceItems.setIn([key, "widthRatio"], item.get("widthRatio"));
          if(item.get("heightRatio") !== undefined)
            workspaceItems = workspaceItems.setIn([key, "heightRatio"], item.get("heightRatio"));
        }

        if (item.get("type") === "TXTOVLY" || item.get("type") === "GROUP")
        {
          var groupItems = state.project.getIn(["scenes", selectedScene, "workspaceChildren"]);

          item.get("groupChildren").entrySeq().forEach(([childKey, itemId]) =>
          {
            let child = action.data.children.get(itemId);
            let childItem = groupItems.get(itemId);

            if (child.get("type") === "TEXT") {
              let isFixedWidth = childItem.getIn(["textData", "formats", "others", "fixedWidth"]);
              if (!isFixedWidth)
                childItem = childItem.setIn(["textData", "formats", "others", "fixedWidth"], true);
              childItem = childItem.setIn(["textData", "formats", "containerStyle", "fontSize"], child.getIn(["textData", "formats", "containerStyle", "fontSize"]));
            }
            
            var childToUpdate = { x: child.get('x'), y: child.get('y'), width: child.get('width'), height: child.get('height') };
            if(child.get("path") !== undefined)
              childToUpdate.path = child.get("path");

            workspaceChildren = workspaceChildren.set(itemId, fromJS(childToUpdate));
            
            if(child.get("type") === "OVLYSVG" && item.get("isExpands") && child.get("groupBounds")){
              workspaceChildren = workspaceChildren.setIn([itemId, "groupBounds"], child.get("groupBounds"));
            }

            if (child.get("type") === "TEXT" || child.get("type") === "SHAPE")
            {
              let isFixedWidth = childItem.getIn(["textData", "formats", "others", "fixedWidth"]);
              if (!isFixedWidth)
                childItem = childItem.setIn(["textData", "formats", "others", "fixedWidth"], true);
              childItem = childItem.setIn(["textData", "formats", "containerStyle", "fontSize"], child.getIn(["textData", "formats", "containerStyle", "fontSize"]));
              
            }
            workspaceChildren = workspaceChildren.setIn([itemId, "textData"], childItem.get("textData"));
          })
        }

      });

    store.dispatch(moveUpdateComplete(selectedScene, workspaceItems, workspaceChildren, currentContainer, action.socket.id, action.socket.id))
    action.socket.emit('moveUpdate', selectedScene, workspaceItems, workspaceChildren, currentContainer, userId);    
  }

  if (action.type === "DUPLICATE_SCENE")
  {
    
    var currentSlide = action.data
    var newslide = state.project.getIn(["scenes", currentSlide]);
    action.playHeadValue = newslide.get("startTime")+newslide.get("duration");
    let newWorkspaceItem = {}, newWorkspaceChildren = {};
    state.project.getIn(["scenes", currentSlide, "workspaceItems"]).entrySeq().forEach(([key, value]) =>
    {
      let childIds = [];
      if(value.get("type") === "GROUP"){
       
        value.get("groupChildren").entrySeq().forEach(([cKey, childId]) =>
        {
          let uniqueId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();
          let child = newslide.getIn(["workspaceChildren", childId]);
          newWorkspaceChildren[uniqueId] = child.toJS();
          childIds.push(uniqueId);
        });
       
        value = value.set("groupChildren", fromJS(childIds));
      }

      newWorkspaceItem[Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()] = value;
    });
    newWorkspaceItem = fromJS(newWorkspaceItem);
    newWorkspaceItem = newWorkspaceItem.sortBy(function (value, key)
    {
      return value.get("index");
    });
    newslide = newslide.set("workspaceItems", newWorkspaceItem.toOrderedMap().toJS());
    newslide = newslide.set("workspaceChildren", newWorkspaceChildren);
    let newId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();
    
    newslide  = newslide.set("id", newId);
    let duration = state.project.get("duration");
    let newDuration = state.project.get("duration") + newslide.getIn(["workspaceBG","videoEnd"]);

    store.dispatch(duplicateSceneComplete(currentSlide + 1, newslide.toJS(), action.socket.id, action.socket.id))
    action.socket.emit('duplicateScene', currentSlide + 1, newslide.toJS(), userId)    
  }

  if (action.type === "REMOVE_SCENE")
  {

    if(Number.isNaN(action.data)) {
      action.data = action.data.index;
    }

    let sceneNumber = action.data === 0?0:action.data-1;
    action.playHead= state.localStore.get("visibleTimelineTab")!=="musicTab"?0:state.project.getIn(["scenes",sceneNumber,"startTime"]);
    let currentSceneStartTime = state.project.getIn(['scenes',action.data, "startTime"]);
    let currentSceneEndTime = currentSceneStartTime+state.project.getIn(['scenes',action.data, "duration"])
    action.sceneStart = state.project.getIn(["scenes",sceneNumber,"startTime" ]);
    action.oldDuration = state.project.get("duration");
    action.selectedSceneDuration= state.project.getIn(["scenes", sceneNumber, "duration"]);
    action.totalDuration = state.project.get("duration")-state.project.getIn(["scenes", action.data, "duration"]);
    
    let localSelectedScene = state.localStore.get("selectedScene");
    let nextSelectedscene = state.localStore.get("selectedScene");
    if(action.currentSocketId === action.socketId || action.data===localSelectedScene){
      nextSelectedscene= (action.data === 0)?0:action.data <= localSelectedScene?localSelectedScene - 1:localSelectedScene
    }
    else if(action.data <= localSelectedScene){
      nextSelectedscene = (localSelectedScene === 0)?0:localSelectedScene- 1;
    }
    action.selectedSceneDuration= state.project.getIn(["scenes", nextSelectedscene, "duration"]);
    action.newPlayheadVaue=state.project.getIn(["scenes",nextSelectedscene,"startTime"]);
    
    store.dispatch(removeSceneComplete(action.data, action.socket.id, action.socket.id));
    action.socket.emit('removeScene', action.data, userId);   
  }

  if (action.type === "ADD_SCENE_TRANSITION")
  {
    store.dispatch(addSceneTransitionComplete(action.slideIndex, action.data, action.sizes, action.socket.id, action.socket.id))
    action.socket.emit('addSceneTransition', action.slideIndex, action.data, action.sizes.toJS(), userId)    
  }

  if (action.type === "UPDATE_SCENE")
  {
    store.dispatch(updateSceneComplete(projectid, action.data.selectedScene, action.data.toUpdate, true, action.socket.id, action.socket.id));
    action.socket.emit("updateSceneValue", action.data.selectedScene, action.data.toUpdate, true, userId);   
  }

  if (action.type === "CHANGE_ACTION")
  {
    let toUpdate = fromJS({ animdata: action.label.get("animdata"), expression: action.label.get("expression"), height: action.label.get("height"), width: action.label.get("width"), pose: action.label.get("pose"), src: action.label.get("src"), expFlag: action.label.get("expFlag"), isRepeated: action.label.get("isRepeated"), mouthAction: action.label.get("mouthAction"), colors: action.label.get("colors"), defaultColor : action.label.get("defaultColor") });

    store.dispatch(updateObjectComplete(projectid, action.selectedScene, action.id, "workspaceItems", toUpdate.toJS(), action.socket.id, action.socket.id));
    action.socket.emit('updateObject', action.selectedScene, action.id,  "workspaceItems", toUpdate.toJS(), true, userId);    
  }

  if (action.type === "CHANGE_EXPRESSION")
  {
    store.dispatch(changeExpressionComplete(action.selectedScene, action.id, action.label, action.socket.id, action.socket.id))

    action.socket.emit('changeExpression', action.selectedScene, action.id, action.label, userId)    
  }

  if (action.type === "CHANGE_VIDEO_VOLUME")
  {
    store.dispatch(changeVideoVolumeComplete(action.data.selectedScene, action.data.value, action.socket.id, action.socket.id))
    action.socket.emit('changeVideoVolume', action.data.selectedScene, action.data.value, userId)    
  }

  if (action.type === "DROP_BG" || action.type === "CHANGE_BG")
  { 
    if(action.data.isRemoveFrmBg){
      let enterStart = 0,
      exitEnd = state.project.getIn(['scenes', action.data.selectedScene, 'duration']);
      var enterEnd = 0, exitStart = 0, enterEffectName = "no_Effect",flipPosition = 0, childIds = [];
  
      if (exitEnd - enterStart <= 1 && exitEnd >= 2)
        enterStart = exitEnd - 2;
      if (enterStart === exitEnd)
        enterStart = 0;
      
      let itemToAdd  = Object.assign(action.data.itemToAdd, {enterStart,enterEnd,enterEffectName});
      let workspaceItems = state.project.getIn(["scenes", action.data.selectedScene, "workspaceItems"]);
      workspaceItems = workspaceItems.set(action.data.itemToAdd.id, itemToAdd).toJS();
  
      let workspaceBG = state.project.getIn(["scenes", action.data.selectedScene, "workspaceBG"]);
      workspaceBG = workspaceBG.delete("videoDuration");
      workspaceBG = workspaceBG.delete("duration");
      workspaceBG = workspaceBG.delete("volume");
      workspaceBG = workspaceBG.set("src", "");
      workspaceBG = workspaceBG.set("thumbnail", "");
      workspaceBG = workspaceBG.set("type", "");
      workspaceBG = workspaceBG.set("subType", "");
      workspaceBG = workspaceBG.set("stockId", "");
      workspaceBG = workspaceBG.set("flipPosition", 0);
      workspaceBG = workspaceBG.set("angle", 0);
      workspaceBG = workspaceBG.set("bgFilter", "");
      workspaceBG = workspaceBG.set("videoStart", 0);
      workspaceBG = workspaceBG.set("isBlob", false);
      workspaceBG = workspaceBG.set("videoEnd", state.project.getIn(["scenes", action.data.selectedScene, "duration"]));
  
      let toUpdate = {workspaceItems : workspaceItems, workspaceBG : workspaceBG.toJS()};
     
      store.dispatch(updateSceneComplete(projectid, action.data.selectedScene, toUpdate, true, action.socket.id, action.socket.id));
      action.socket.emit("updateSceneValue", action.data.selectedScene, toUpdate, true, userId);      
    }
    else{
    let bgWidth = action.data.bgWidth, bgHeight = action.data.bgHeight, bgScale = null, bgWidthScale = null, bgHeightScale = null;

    var workspaceWidth = state.project.get("width");
    var workspaceHeight = state.project.get("height");
    if((state.localStore.get("anymsUploadStatus") !== "processing" && !action.data.isSample) || (action.data.bgType !== "STOCKVID" && action.data.bgType !== "UPVIDEO")){
      if (workspaceWidth >= workspaceHeight)
      {
        bgWidth = workspaceWidth;
        bgHeight = action.data.bgHeight * (bgWidth / action.data.bgWidth);
        if (bgHeight <= workspaceHeight)
        {
          bgHeight = workspaceHeight;
          bgWidth = bgWidth * (bgHeight / (action.data.bgHeight * (bgWidth / action.data.bgWidth)));
        }
      } 
      else
      {
        bgHeight = workspaceHeight;
        bgWidth = action.data.bgWidth * (bgHeight / action.data.bgHeight);
        if (bgWidth <= workspaceWidth)
        {
          bgWidth = workspaceWidth;
          bgHeight = bgHeight * (bgWidth / (action.data.bgWidth * (bgHeight / action.data.bgHeight)));
        }
      }
    }else{
      if (workspaceWidth >= workspaceHeight)
      {
        bgWidth = workspaceWidth;
        bgHeight = action.data.bgHeight * (bgWidth / action.data.bgWidth);
        if (bgHeight >= workspaceHeight)
        {
          bgHeight = workspaceHeight;
          bgWidth = bgWidth * (bgHeight / (action.data.bgHeight * (bgWidth / action.data.bgWidth)));
        }
      } 
      else
      {
        bgHeight = workspaceHeight;
        bgWidth = action.data.bgWidth * (bgHeight / action.data.bgHeight);
        if (bgWidth >= workspaceWidth)
        {
          bgWidth = workspaceWidth;
          bgHeight = bgHeight * (bgWidth / (action.data.bgWidth * (bgHeight / action.data.bgHeight)));
        }
      }
    }
    
    bgWidthScale = bgWidth / workspaceWidth;
    bgHeightScale = bgHeight / workspaceHeight;
    
    let dW = workspaceWidth - bgWidth, dH = workspaceHeight - bgHeight;
    if(isNaN(dW))
      dW = 0

    if(isNaN(dH))
      dH = 0
  
    var x = (dW / 2) / workspaceWidth, y = (dH / 2) / workspaceHeight, width = bgWidthScale, height = bgHeightScale;

    selectedScene = action.data.selectedScene;
    var workspaceBG = state.project.getIn(["scenes", selectedScene, "workspaceBG"]).toJS()
   
    if(state.localStore.get("anymsUploadStatus") === "processing" || action.data.isSample)
      workspaceBG.color = fromJS(["#000000"]);

    workspaceBG.src = action.data.source;
    workspaceBG.thumbnail = action.data.thumb;
    workspaceBG.type = action.data.bgType;
    workspaceBG.enterStart = 0;
    workspaceBG.exitEnd = state.project.getIn(["scenes", selectedScene, 'duration']);
    workspaceBG.x = x;
    workspaceBG.y = y;
    workspaceBG.width = width;
    workspaceBG.height = height;
    workspaceBG.angle = 0;
    workspaceBG.flipPosition = 0;
    workspaceBG.assetId = action.data.assetId;

    if(action.data.actualWidth){
      workspaceBG.actualWidth = action.data.actualWidth;
      workspaceBG.actualHeight = action.data.actualHeight;
      workspaceBG.actualX = x;
      workspaceBG.actualY = y;
    }
    let droppedDuration = state.project.getIn(["scenes", selectedScene, 'duration']);
    if(action.data.bgFilter !== undefined)
      workspaceBG.bgFilter = action.data.bgFilter;
    if(action.data.flipPosition !== undefined)
      workspaceBG.flipPosition = action.data.flipPosition;

    if(action.data.sourceType !== undefined)
      workspaceBG.sourceType = action.data.sourceType;
    workspaceBG.duration = state.project.getIn(["scenes", selectedScene, 'duration']);
    workspaceBG.videoDuration = workspaceBG.duration;
    if(action.data.subType !== undefined)
      workspaceBG.subType = action.data.subType;
    else 
      workspaceBG.subType = "";
      
    if(action.data.bgType === "STOCKIMG" || action.data.bgType === "STOCKVID" || action.data.bgType === "GIPHY")
      workspaceBG.stockId = action.data.stockId;
    if (action.data.bgType === "VIDEO" || action.data.bgType === "STOCKVID" || action.data.bgType === "UPVIDEO")
    {
      workspaceBG.videoStart = 0
      workspaceBG.videoEnd =   workspaceBG.duration
      workspaceBG.duration = action.data.duration;
      droppedDuration = action.data.duration;
      workspaceBG.displaysizes = action.data.displaysizes;
      workspaceBG.volume = 100;
      if (action.data.bgType === "STOCKVID" || action.data.bgType === 'VIDEO')
      {
        workspaceBG.poster = action.data.poster;
        workspaceBG.videoDuration = action.data.videoDuration;
      }
      if(action.data.bgType === "UPVIDEO")
      {
        workspaceBG.videoDuration = action.data.duration;
      }
    }
    else
    {
      workspaceBG.bgColor = action.data.color;
      workspaceBG.defaultColor = action.data.defaultColor ? action.data.defaultColor : action.data.color;
      workspaceBG.hasGradient = action.data.hasGradient;
      workspaceBG.videoStart = 0
      workspaceBG.videoEnd =   state.project.getIn(["scenes", selectedScene, "duration"])
      workspaceBG.videoDuration = state.project.getIn(["scenes", selectedScene, "workspaceBG", "videoDuration" ]);
    }

    if(action.data.isBlob !== undefined){
      workspaceBG.isBlob = action.data.isBlob;
    }

    workspaceBG.exitEnd = workspaceBG.duration
  
    var deleteId = "";
    if(action.data.isCustomBg === true)
      deleteId = action.data.selectedItems.get(0);

    if (!state.localStore.get("addNewScene"))
    {
      action.totalDuration = droppedDuration+state.project.get("duration")-state.project.getIn(["scenes",selectedScene, "duration"]);
      workspaceBG.videoEnd =   action.data.videoDuration
      if(action.data.isTrimedVideo){
        setTimeout(()=>{
         store.dispatch(loadCommonPopup("VIDEO", false));
            },400);
          }
      if(workspaceBG.videoDuration === undefined)
        workspaceBG.videoDuration = state.project.getIn(["scenes", selectedScene, "duration"]);
       
        let duration = state.project.get("duration");
        let newDuration = state.project.get("duration") + workspaceBG.videoDuration-state.project.getIn(["scenes", selectedScene, "duration"]);
        if(workspaceBG.videoDuration<state.project.getIn(["scenes", selectedScene, "duration"])){
          newDuration = state.project.get("duration") - (state.project.getIn(["scenes", selectedScene, "duration"]) - workspaceBG.videoDuration);
        }
        
      store.dispatch(changeBgComplete(selectedScene, workspaceBG, deleteId, action.deleteData, action.socket.id, action.socket.id))
      action.socket.emit('changeBg', selectedScene, workspaceBG, deleteId, action.deleteData, userId)      
    }
    else {
      workspaceBG.enterStart = 0;
      if (action.data.bgType === "VIDEO" || action.data.bgType === "STOCKVID" || action.data.bgType === "UPVIDEO")
      {
        workspaceBG.exitEnd = action.data.duration;
        workspaceBG.videoEnd = action.data.duration;
        workspaceBG.displaysizes = action.data.displaysizes;
      }
        workspaceBG.videoEnd = action.data.videoDuration

      var totalDuration = 0;
      for (var i = 0; i < state.project.getIn(['scenes']).size; i++) {
        totalDuration += state.project.getIn(['scenes', i, 'duration']);
      }

      var slideIndex = state.project.getIn(["scenes"]).size;
      var newslide = {
        "id" : Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString(),
        "duration": (action.data.duration === undefined)?sceneDuration:action.data.duration,
        "workspaceChildren": {},
        "workspaceItems": {},
        "workspaceBG": workspaceBG,
        "startTime": totalDuration,
        "transEffect": "NoTransition"
      }

      if (action.data.slide !== undefined) {
        newslide = action.data.slide.toJS();
      }

      
      let duration = state.project.get("duration");
      let newDuration = state.project.get("duration") + newslide["duration"];


      action.totalDuration = newDuration;
      store.dispatch(addSceneComplete(slideIndex, newslide, action.socket.id, action.socket.id))
      action.socket.emit('addScene', slideIndex, newslide, userId)      
    }
  }
  }

  if (action.type === "DELETE_BG")
  {
    let workspaceBG = state.project.getIn(["scenes", action.data.selectedScene, "workspaceBG"]);
    workspaceBG = workspaceBG.delete("videoDuration");
    workspaceBG = workspaceBG.delete("duration");
    workspaceBG = workspaceBG.delete("volume");
    workspaceBG = workspaceBG.set("src", "");
    workspaceBG = workspaceBG.set("thumbnail", "");
    workspaceBG = workspaceBG.set("type", "");
    workspaceBG = workspaceBG.set("subType", "");
    workspaceBG = workspaceBG.set("stockId", "");
    workspaceBG = workspaceBG.set("flipPosition", 0);
    workspaceBG = workspaceBG.set("angle", 0);
    workspaceBG = workspaceBG.set("bgFilter", "");
    workspaceBG = workspaceBG.set("videoStart", 0);
    workspaceBG = workspaceBG.set("isBlob", false);
    workspaceBG = workspaceBG.set("videoEnd", state.project.getIn(["scenes", action.data.selectedScene, "duration"]));
    if(action.data.color){
      workspaceBG = workspaceBG.set("color", action.data.color);
      workspaceBG = workspaceBG.set("isRadial", action.data.isRadial);
      workspaceBG = workspaceBG.set("radius", action.data.radius);
      workspaceBG = workspaceBG.set("direction", action.data.direction);
    }
    store.dispatch(changeBgComplete(action.data.selectedScene, workspaceBG.toJS(), "", [], action.socket.id, action.socket.id))

    action.socket.emit('changeBg', action.data.selectedScene, workspaceBG.toJS(), "", [], userId)    
  }
  
  if (action.type === "APPLY_FILTER")
  {
    store.dispatch(applyFilterComplete(action.selectedScene, action.active, action.filterCode, action.socket.id, action.socket.id))
    action.socket.emit('applyFilter', action.selectedScene, action.active, action.filterCode, userId)    
  }

  if (action.type === "UPDATE_SVGCOLOR")
  {
    var container = "workspaceItems";
    if (action.container !== undefined)
      container = action.container;

      if(state.project.getIn(["scenes", action.selectedScene, container, action.id, "type"]) === "SHAPE"){
        let path = state.project.getIn(["scenes", action.selectedScene, container, action.id, "path"]);
        let colors = state.project.getIn(["scenes", action.selectedScene, container, action.id, "colors"]);
       
        path = path.setIn([colors.keySeq().toList().findIndex(x => x === action.cls), "color"], action.color);
       
        store.dispatch(updateObjectComplete(projectid, action.selectedScene, action.id, container, {path : path.toJS()}, action.socket.id, action.socket.id));
        action.socket.emit('updateObject', action.selectedScene, action.id, container, {path : path.toJS()}, true, userId);        
      }

      store.dispatch(updateSvgColorComplete(action.selectedScene, container, action.id, action.cls, action.color, action.socket.id, action.socket.id))
     
      action.socket.emit('updateSvgColor', action.selectedScene, container, action.id, action.cls, action.color, userId);      
    }

  if (action.type === "UPDATE_SVG_THEME")
  {
    var container = "workspaceItems";
    if (action.container !== undefined)
      container = action.container;
   
    store.dispatch(updateSvgThemeComplete(projectid, action.selectedScene, container, action.id, action.colorData.toJS(), action.isBG, action.socket.id, action.socket.id))

    action.socket.emit('updateSvgTheme', action.selectedScene, container, action.id, action.colorData, action.isBG, userId);    
  }

  if (action.type === "FLIP_ITEM")
  {
    store.dispatch(flipItemComplete(action.data.selectedScene, action.data.active, action.data.flipPosition, action.socket.id, action.socket.id))

    action.socket.emit('flipItem', action.data.selectedScene, action.data.active, action.data.flipPosition, userId)    
  }

  if (action.type === "CROP_IMAGE")
  {
    selectedScene = action.data.selectedScene;
    var selectedItem = state.project.getIn(["scenes", selectedScene, "workspaceItems", action.data.selectedItems.get(0)]);
   
    if(action.data.original.x === 0 && action.data.original.y === 0 && action.data.original.width === 1 && action.data.original.height === 1){
      let original = selectedItem.delete("original");
      
      selectedItem = selectedItem.set("isCropped", false);
      selectedItem = selectedItem.delete("original");
    }else{
      selectedItem = selectedItem.merge(fromJS(action.data.crop));
    
      selectedItem = selectedItem.set("original", fromJS(action.data.original));
      if (action.data.isCropping)
        selectedItem = selectedItem.set("isCropped", true);
    }
   
    store.dispatch(cropImageComplete(action.data.selectedScene, action.data.selectedItems.get(0), selectedItem.toJS(), action.socket.id, action.socket.id))

    action.socket.emit('cropImage', action.data.selectedScene, action.data.selectedItems.get(0), selectedItem.toJS(), userId)    
  }

  if (action.type === "CROP_BG")
  {
    selectedScene = action.data.selectedScene;

    var workspaceBg = state.project.getIn(["scenes", action.data.selectedScene, 'workspaceBG']).toJS();
    if (!action.data.isVideo)
    {
      workspaceBg.x = action.data.bgScales.x;
      workspaceBg.y = action.data.bgScales.y;
      workspaceBg.width = action.data.bgScales.width;
      workspaceBg.height = action.data.bgScales.height;
    }
    else
      state = state.setIn(["videos", action.data.videoId, "bgScales"], fromJS(action.data.bgScales));

    store.dispatch(cropBgComplete(action.data.selectedScene, workspaceBg, action.data.isVideo, action.data.videoId, action.data.bgScales, action.socket.id, action.socket.id))

    action.socket.emit('cropBg', action.data.selectedScene, workspaceBg, action.data.isVideo, action.data.videoId, action.data.bgScales, userId)    
  }

  if (action.type === "BG_COLOR_SELECTION")
  {
    let colorArray = state.project.getIn(["scenes", action.selectedScene, "workspaceBG", "color"]);
    if (action.deletePosition >= 0 && action.deletePosition !== null)
    {
      colorArray = colorArray.remove(action.deletePosition)
    } else
    {
      if (action.enteredColorPosition !== null)
      { 
        colorArray = colorArray.setIn([action.enteredColorPosition], action.value.toUpperCase());
      } else
      {
        if (Array.isArray(action.value))
        {
          colorArray = action.value

        } else if (colorArray !== undefined && colorArray.size >= 0)
        {
            colorArray = colorArray.push(action.value.toUpperCase())
        }
      }
    }

    store.dispatch(bgColorSelectionComplete(action.selectedScene, colorArray, action.socket.id, action.socket.id))

    action.socket.emit('bgColorSelection', action.selectedScene, colorArray, userId)    
  }

  if (action.type === "BG_GRADIENT_COLORS")
  {
    store.dispatch(bgGradientColorsComplete(action.selectedScene, action.radialStatus,action.value,action.radius, action.socket.id, action.socket.id));
    action.socket.emit('bgGradientColors', action.selectedScene, action.radialStatus,action.value,action.radius, userId)    
  }

  if (action.type === "UPDATE_BGCOLOR")
  {
   
    store.dispatch(updateBgColorComplete(action.selectedScene, action.cls, action.color, action.socket.id, action.socket.id))
    action.socket.emit('updateBgColor', action.selectedScene, action.cls, action.color, userId)    
  }

  if (action.type === "UPDATE_BGGRADIENT")
  {
    var gradientIndex = action.cls.charAt(0);
    var gradientSecIndex = action.cls.charAt(1);

    store.dispatch(updateBgGradientComplete(action.selectedScene, gradientIndex, gradientSecIndex, action.color, action.socket.id, action.socket.id)) 
    action.socket.emit('updateBgGradient', action.selectedScene, gradientIndex, gradientSecIndex, action.color, userId)    
  }

  if (action.type === "SET_SELECTED_ITEMS")
  {
    action.selectedSceneDuration = state.project.getIn(["scenes", state.localStore.get("selectedScene"), "duration"]);
    store.dispatch(setSelectedItemsComplete(projectid, action.data.selectedItems[0], projectUsr, userId,projectUsrImg,socketid, socketid))  
    action.socket.emit('setSelectedItems', action.data.selectedItems[0], projectUsr,userId,projectUsrImg, userId)    
  }

  if (action.type === "SET_SELECTED_SCENE")
  {
    action.oldduration = state.project.getIn(["scenes",state.localStore.get("selectedScene"),"duration"])
    action.newduration = state.project.getIn(["scenes",action.selectedScenes[0],"duration"])
    action.playHead =  state.project.getIn(["scenes",action.selectedScenes[0],"startTime"]);
    store.dispatch(setSelectedSceneComplete(projectid, action.selectedScenes[0], projectUsr, userId,projectUsrImg, action.socket.id, action.socket.id))
    action.socket.emit('setSelectedScene', action.selectedScenes[0], projectUsr,userId,projectUsrImg, userId)    
  }

  if (action.type === "CHANGE_TEXT")
  {
    
    store.dispatch(changeTextComplete(action.data.selectedScene, action.data.container, action.data.active, (action.data.text).toJS(), action.socket.id, action.socket.id, true));
    action.socket.emit('changeText', action.data.selectedScene, action.data.container, action.data.active, action.data.text, userId)    
  }
 
  if(action.type === "UPDATE_GROUP_TEXT"){
    if(!state.localStore.get("isPlay") && !state.localStore.get("isPlayAll")){
      var selectedScene = action.data.selectedScene;
      var groupId = action.data.groupId, currentId = action.data.currentId;

      let aboveY, belowY, curY, curHeight;
      let aboveHeight, belowHeight;
      if(action.data.verticalAlign === "middle"){
        aboveY = -1 * (action.data.dH/2); belowY = (action.data.dH/2); curY = -1 * (action.data.dH/2); curHeight = action.data.dH;
        aboveHeight = 0; belowHeight = 0;
      }
      else if(action.data.verticalAlign === "bottom"){
        aboveY = -1 * action.data.dH; belowY = 0; curY = -1 * action.data.dH; curHeight = action.data.dH;
        aboveHeight = 0; belowHeight = 0;
      }
      else {
        if(action.data.isPrebuilt){
          aboveY = 0; belowY = action.data.dH < 0 ? 0 : action.data.dH ; curY = 0; curHeight = action.data.dH < 0 ? 0 : action.data.dH;
        aboveHeight = 0; belowHeight = 0;
        }
        else{
        aboveY = 0; belowY = action.data.dH  ; curY = 0; curHeight = action.data.dH;
        aboveHeight = 0; belowHeight = 0;
        }
      }

      var childIds = state.project.getIn(["scenes", selectedScene, "workspaceItems", groupId, "groupChildren"]);
      var children = state.project.getIn(["scenes", selectedScene, "workspaceChildren"]).filter(function(obj, key){return childIds.keyOf(key) !== undefined;});

      var workspaceItems    = fromJS({});
      var workspaceChildren = fromJS({});

      var allChildren       = state.project.getIn(["scenes", selectedScene, "workspaceChildren"]);
      var allWorkspaceItems = state.project.getIn(["scenes", selectedScene, "workspaceItems"]);
      if(action.data.isGrouped){
        children.entrySeq().forEach(([key, item]) => {
          if(key === currentId){
            workspaceChildren = workspaceChildren.setIn([key, "y"], parseFloat((item.get("y") + curY).toFixed(2)));
            workspaceChildren = workspaceChildren.setIn([key, "height"], parseFloat((item.get("height") + curHeight).toFixed(2)));
            if(action.data.textData !== undefined)
              workspaceChildren = workspaceChildren.setIn([key, "textData"], action.data.textData);
          }
          else if(item.get("y") < (action.data.itemY))
          {
            workspaceChildren = workspaceChildren.setIn([key, "y"], parseFloat((item.get("y") + aboveY).toFixed(2)));
            workspaceChildren = workspaceChildren.setIn([key, "height"], parseFloat((item.get("height") + aboveHeight).toFixed(2)));
          }else{
            workspaceChildren = workspaceChildren.setIn([key, "y"], parseFloat((item.get("y") + belowY).toFixed(2)) );
            workspaceChildren = workspaceChildren.setIn([key, "height"], parseFloat((item.get("height") + belowHeight).toFixed(2)));
          } 
        });

        var parentItem = allWorkspaceItems.get(groupId);
        workspaceItems = workspaceItems.setIn([groupId, "y"], parseFloat((parentItem.get("y") + curY).toFixed(2)));
        workspaceItems = workspaceItems.setIn([groupId, "height"], parseFloat((parentItem.get("height") + curHeight).toFixed(2)));
        
      }else{
        var siblings = state.project.getIn(["scenes", selectedScene, "workspaceItems"]).filter(function(obj, key){return action.data.selectedItems.keyOf(key) !== undefined;});
        siblings.entrySeq().forEach(([key, item]) => {
          if(key === currentId){
            workspaceItems = workspaceItems.setIn([key, "y"], parseFloat((item.get("y") + curY).toFixed(2)));
            workspaceItems = workspaceItems.setIn([key, "height"], parseFloat((item.get("height") + curHeight).toFixed(2)));
            if(action.data.textData !== undefined)
            workspaceItems = workspaceItems.setIn([key, "textData"], action.data.textData);
          }
          else if(item.get("y") < (action.data.itemY))
          {
            workspaceItems = workspaceItems.setIn([key, "y"], parseFloat((item.get("y") + aboveY).toFixed(2)));
            workspaceItems = workspaceItems.setIn([key, "height"], parseFloat((item.get("height") + aboveHeight).toFixed(2)));
          }else {
            workspaceItems = workspaceItems.setIn([key, "y"], parseFloat((item.get("y") + belowY).toFixed(2)));
            workspaceItems = workspaceItems.setIn([key, "height"], parseFloat((item.get("height") + belowHeight).toFixed(2)));
          } 
        });
      }
      
      store.dispatch(updateGroupTextComplete(action.data.selectedScene, workspaceItems.toJS(), workspaceChildren.toJS(), action.socket.id, action.socket.id, true));
     
      action.socket.emit("updateGroupText", action.data.selectedScene, workspaceItems.toJS(), workspaceChildren.toJS(), userId);      
    }
  }

  if (action.type === "DELETE_ITEM")
  {
    var selectedItems = action.data.selectedItems;
    var selectedScene = action.data.selectedScene;
    var workspaceItems = fromJS({});
    var childIds = [];
    for (var i = 0; i < selectedItems.length; i++)
    {
      if (state.project.getIn(["scenes", selectedScene, "workspaceItems", selectedItems[i], "type"]) === "GROUP")
      {
        childIds = childIds.concat(state.project.getIn(["scenes", selectedScene, "workspaceItems", selectedItems[i], "groupChildren"]).toJS());
      }
    }
    var getAllItems = state.project.getIn(["scenes", selectedScene, "workspaceItems"]);
    getAllItems = selectedItems.reduce((map, key) => map.delete(key), getAllItems);
    i = 0;
    getAllItems.entrySeq().forEach(([key, value]) =>
    {
      workspaceItems = workspaceItems.setIn([key, "index"], i);
      workspaceItems = workspaceItems.setIn([key, "animIndex"], i);
      i++;
    });
    
    store.dispatch(deleteItemComplete(action.data.selectedScene, selectedItems, childIds, workspaceItems, action.socket.id, action.socket.id));
    action.socket.emit("deleteItem", action.data.selectedScene, selectedItems, childIds, workspaceItems, userId)    
  }

  if (action.type === "SET_Z_INDEX")
  {
    var selectedScene = action.data.selectedScene;
    var workspaceItems = fromJS({});

    let currentIndex = state.project.getIn(["scenes", selectedScene, "workspaceItems", action.data.selectedItem, "index"]);
    let nextKey = null, prevKey = null, nextItem = null, prevItem = null;
    let maxObjects = state.project.getIn(["scenes", selectedScene, "workspaceItems"]).filter(function (obj, key) { return obj.get("index") > currentIndex });
    let minObjects = state.project.getIn(["scenes", selectedScene, "workspaceItems"]).filter(function (obj, key) { return obj.get("index") < currentIndex });

    if (maxObjects.size > 0)
    {
      nextItem = maxObjects.first();
      nextKey = maxObjects.keySeq().toArray()[0];
    }

    if (minObjects.size > 0)
    {
      prevItem = minObjects.last();
      let minKeys = minObjects.keySeq().toArray();
      prevKey = minKeys[minKeys.length - 1];
    }

    if (action.data.to === "front" && nextItem !== null)
    {
      workspaceItems = workspaceItems.setIn([action.data.selectedItem, "index"], nextItem.get("index"));
      workspaceItems = workspaceItems.setIn([nextKey, "index"], currentIndex);
    }
    else if (action.data.to === "back" && prevItem !== null)
    {
      workspaceItems = workspaceItems.setIn([action.data.selectedItem, "index"], prevItem.get("index"));
      workspaceItems = workspaceItems.setIn([prevKey, "index"], currentIndex);
    } else if (action.data.to === "first")
    {
      let count = 0;
      state.project.getIn(["scenes", selectedScene, "workspaceItems"]).entrySeq().forEach(([key, value]) =>
      {
        if (action.data.selectedItem === key)
        {
          workspaceItems = workspaceItems.setIn([key, "index"], state.project.getIn(["scenes", selectedScene, "workspaceItems"]).size - 1);
        } else
        {
          workspaceItems = workspaceItems.setIn([key, "index"], count);
          count++;
        }
      });
    }
    else if (action.data.to === "last")
    {
      let count = 1;
      state.project.getIn(["scenes", selectedScene, "workspaceItems"]).entrySeq().forEach(([key, value]) =>
      {
        if (action.data.selectedItem === key)
        {
          workspaceItems = workspaceItems.setIn([key, "index"], 0);
        } else
        {
          workspaceItems = workspaceItems.setIn([key, "index"], count);
          count++;
        }
      });
    }
    
    store.dispatch(setZIndexComplete(action.data.selectedScene, workspaceItems, action.socket.id, action.socket.id));
    action.socket.emit("setZIndex", action.data.selectedScene, workspaceItems, userId);    
  }

  if (action.type === "GROUP_OBJECTS")
  {
    store.dispatch(groupObjectsComplete( action.data.selectedScene, action.data.selectedItems.toJS(), action.data.workspaceItems.toJS(), action.data.workspaceChildren.toJS(), action.data.workspaceItemsOrder,action.socket.id, action.socket.id));
    action.socket.emit("groupObjects", action.data.selectedScene, action.data.selectedItems, action.data.workspaceItems, action.data.workspaceChildren,action.data.workspaceItemsOrder, userId);    
  }
  if (action.type === "UNGROUP_OBJECTS")
  {
    store.dispatch(ungroupObjectsComplete( action.data.selectedScene, action.data.selectedItems.toJS(), action.data.workspaceChildren.toJS(),action.data.workspaceItemsOrder, action.socket.id, action.socket.id));
    action.socket.emit("ungroupObjects",  action.data.selectedScene, action.data.selectedItems, action.data.workspaceChildren,action.data.workspaceItemsOrder, userId);    
  }

  if(action.type === "UPDATE_TEXT"){
   
    if(!state.localStore.get("isPlay") && !state.localStore.get("isPlayAll")){
      
      var container = "workspaceItems";
      if (action.data.container !== undefined)
        container = action.data.container;
      selectedScene = action.data.selectedScene;
      let property = action.data.property; 
      var value = action.data.value;
      var childIds = [];
     
      var formats = fromJS({containerStyle : {}, bullet : {}, others : {}});
      
      if(action.data.isPartial === undefined || !action.data.isPartial){
        if (property === "bullet") {
          formats = formats.setIn(["bullet", "type"], value);
        
          if(formats.getIn(["containerStyle", "textAlign"]) !== "left")
            formats = formats.setIn(["containerStyle", "textAlign"], "left");
        }
        else if (property === "bulletSpace") {
          formats = formats.setIn(["bullet", "bulletSpace"], parseInt(value));
        }
        else {
          if (property === "fontSize") {
            if (value === "autopx") {
              formats = formats.setIn(["others", "isAutoFontSize"], true);
            }
            else {
              formats = formats.setIn(["others", "isAutoFontSize"], false);
            }
            formats = formats.setIn(["others", "sizeFixed"], true);
          }
          formats = formats.setIn(["containerStyle", property], value);
        }

        if(property === "fontFamily" && action.data.textData !== undefined){
          if(action.data.lineHeight !== undefined)
            formats = formats.setIn(["containerStyle", "lineHeight"], action.data.lineHeight);
          formats = formats.set("others", action.data.textData.getIn(["formats", "others"]));
        }
       
      }
      else if(property === "bullet" || property === "fontSize" || property === "fontFamily"){
        if(property === "bullet"){
          formats = formats.setIn(["bullet", "type"], value);
          if(formats.getIn(["containerStyle", "textAlign"]) !== "left")
            formats = formats.setIn(["containerStyle", "textAlign"], "left");
        }
        else if (property === "fontSize") {
          if (value === "autopx") 
            formats = formats.setIn(["others", "isAutoFontSize"], true);
          else 
            formats = formats.setIn(["others", "isAutoFontSize"], false);
            formats = formats.setIn(["others", "sizeFixed"], true);
        }
      }

      var textData = state.project.getIn(["scenes", action.data.selectedScene, action.data.container, action.data.id, "textData"]);
    
      textData     = textData.set("formats", textData.get("formats").mergeDeep(formats));
      
      if(action.data.htmlText !== undefined)
        textData = textData.set("htmlText", action.data.htmlText);
      var toUpdate = {textData : textData.toJS()};

        if(action.data.width !== undefined)
          toUpdate.width = action.data.width;
        if(action.data.height !== undefined)
          toUpdate.height = action.data.height;
        if(action.data.yRatio !== undefined)
          toUpdate.yRatio = action.data.yRatio;
        if(action.data.heightRatio !== undefined)
          toUpdate.heightRatio = action.data.heightRatio;
     
      store.dispatch(updateObjectComplete(projectid, action.data.selectedScene, action.data.id, action.data.container, toUpdate, action.socket.id, action.socket.id));
      action.socket.emit('updateObject', action.data.selectedScene, action.data.id, action.data.container, toUpdate, true, userId);      
    }
  }

  if (action.type === "UPDATE_TIMELINE_DRAG")
  {
    var childToUpdate = fromJS({});
    if(action.item === "workspaceItems"){
      let minDuration = 0.1;
      var items = fromJS(action.data).filter(x => x.get("name") === "enterStart" || x.get("name") === "exitEnd").groupBy(x => x.get("id"));
      items.entrySeq().forEach(([keyVal, item]) => {
        
        if(state.project.getIn(["scenes", action.selectedScene, "workspaceItems", keyVal, "type"]) === "GROUP"){
          let enterItem = item.find(x => x.get("name") === "enterStart");
          let exitItem  = item.find(x => x.get("name") === "exitEnd");
          let parent = state.project.getIn(["scenes", action.selectedScene, "workspaceItems", keyVal]);
          let enterDeviation = 0, exitDeviation = 0;
          if(enterItem !== undefined)
            enterDeviation = parseFloat(enterItem.get("value")) - parent.get("enterStart");
          if(exitItem !== undefined)
            exitDeviation = parseFloat(exitItem.get("value")) - parent.get("exitEnd");
          parent.get("groupChildren").entrySeq().forEach(([index, cKey]) => {
            let child = state.project.getIn(["scenes", action.selectedScene, "workspaceChildren", cKey]);
            let enterStart = child.get("enterStart"), exitEnd = child.get("exitEnd"), entDur = 0, extDur = 0;
            
            let currentStart = parent.get("enterStart") + enterDeviation;
              enterStart += enterDeviation;
            let currentEnd = parent.get("exitEnd") + exitDeviation;
              exitEnd += exitDeviation;

            let chDuration = exitEnd - enterStart;
            if(child.get("type") === "TEXT")
             
           
            if(chDuration < minDuration){
                exitEnd += minDuration * (exitDeviation / (chDuration));
                enterStart -= minDuration * (enterDeviation / (chDuration));
               enterStart=enterStart<0?0:enterStart
            }
            
            if(exitEnd <= currentStart){
              enterStart = currentStart;
              exitEnd    = enterStart + minDuration;
            }
            else if(enterStart >= currentEnd){
              enterStart = currentEnd - minDuration;
              exitEnd    = currentEnd;
            }
            else if(exitEnd >= currentStart && enterStart <= currentStart){
              enterStart = currentStart;
              if(exitEnd - enterStart < minDuration)
                exitEnd = enterStart + minDuration;
            }
            else if(enterStart <= currentEnd && exitEnd >= currentEnd){
             
              exitEnd = currentEnd;
              if(exitEnd - enterStart < minDuration)
                enterStart = exitEnd - minDuration;
            }

            var timeScale = (exitEnd - enterStart) / (child.get("exitEnd") - child.get("enterStart"));
            if(child.get("enterEffectName") !== "no_Effect" && child.get("enterEnd") > 0)
              entDur  = child.get("enterEnd") - child.get("enterStart");

          
            if(enterStart + entDur > exitEnd - extDur){
              entDur  = entDur * timeScale > 0.1 ? entDur * timeScale : 0.1;
              extDur  = extDur * timeScale > 0.1 ? extDur * timeScale : 0.1;
            }


            childToUpdate = childToUpdate.setIn([cKey, "enterStart"], parseFloat(enterStart.toFixed(1))).setIn([cKey, "exitEnd"], parseFloat(exitEnd.toFixed(1))).setIn([cKey, "enterEnd"], parseFloat((enterStart + entDur).toFixed(1))).setIn([cKey, "exitStart"], parseFloat((exitEnd - extDur).toFixed(1)));
          })
        }
      })
    }
    let tempDuration = 0;
    let newData = action.data.map((value)=>{
      if(value.name==="duration"){
        tempDuration = value["value"];
      }
      if(value.key==="audioplayhead");
      value.key="playHeadValue"
      return value
      });
      let nextDuration = state.project.get("duration")+(tempDuration-state.project.getIn(["scenes",action.selectedScene,"duration"]) );
      action.nextDuration = parseFloat(nextDuration.toFixed(1));
      action.oldduration = state.project.get("duration");
    store.dispatch(updateTimelineDragChangeComplete(action.selectedScene, action.item, action.data, action.id, childToUpdate.toJS(), action.socket.id, action.socket.id));
    action.socket.emit('updateTimelineDrag', action.selectedScene, action.item, newData, action.id, childToUpdate.toJS(), userId);    
  }

  if (action.type === "UPDATE_TIMELINE_DRAG_COMPLETE")
  {
    selectedScene = action.selectedScene;
      let itr = 0;
      if (action.itemData === "workspaceItems") {
        for (itr = 0; itr < action.actionData.length; itr++) {
          if (action.actionData[itr].name === 'videoStart')
          {
            action.actionData.push({name:"audioplayhead",value:state.project.getIn(['scenes', selectedScene, 'startTime'])})
          }
          else if (action.actionData[itr].name === 'duration')
          {
            action.actionData[itr].sceneStartTime = state.project.getIn(['scenes', selectedScene, 'startTime']);
          }
        }
      }
  }
  
  if (action.type === "PASTE_ITEMS")
  {
  
    let pasteData = action.data;
    selectedScene = pasteData.selectedScene;
    if (pasteData.dataType === "ITEMS")
    {
      workspaceItems = fromJS(pasteData.data.workspaceItems);
      let workspaceChildren = fromJS(pasteData.data.workspaceChildren);
      workspaceItems = workspaceItems.sortBy(function (value, key) {return value.get("index");}).toOrderedMap();
      var workspaceIds = [], workspaceChildIds = [], workspaceData = [], workspaceChildData = [], uniqueId;
      var minTime = workspaceItems.getIn([0, "enterStart"]), maxTime = 0, a = 0;
      for (a = 0; a < workspaceItems.size; a++)
      {
        if(workspaceItems.getIn([a,'type'])!== 'SCR')
        minTime = (minTime < workspaceItems.getIn([a, "enterStart"])) ? minTime : workspaceItems.getIn([a, "enterStart"]);
      }
      let playHead = 0, minDuration = 1;
      let maxItem = state.project.getIn(["scenes", selectedScene, "workspaceItems"]).maxBy(x => x.get("index"));
      
      let nextIndex = 0;
      if(maxItem !== undefined)
        nextIndex = maxItem.get("index");

      let maxAnimItem = state.project.getIn(["scenes", selectedScene, "workspaceItems"]).maxBy(x => x.get("animIndex"));
      let nextAnimIndex = 0 ;
      if(maxAnimItem !== undefined)
        nextAnimIndex = maxAnimItem.get("animIndex");
      for (a = 0; a < workspaceItems.size; a++)
      {
        if(workspaceItems.getIn([a,'type'])!== 'SCR'){
        let {isMultimove,exitEffectName,exitStart,exitEnd,keyframes,...deckworkspaceItems}=(workspaceItems.get(a)).toJS();
        var item = deckworkspaceItems;
        nextIndex++;
        nextAnimIndex++;
        if(item.subType === 'CHR'){
          let urlItems = item.thumb.split('/');
          urlItems[1] = item.charId;
          let thumbUrl = urlItems.join('/');
          item.thumb  = thumbUrl+'.png';
        }
        var playDiff = Math.abs(item.enterStart - minTime);
        playHead = 0;
        var playHeadVal = playHead + playDiff;
        var slideDuration = state.project.getIn(['scenes', selectedScene, "duration"]);

        var itemDuration = item.exitEnd - item.enterStart;
        var prevStart = item.enterStart;
        var prevEnd = item.exitEnd;
       
        var itemEndTime;

        if (playHeadVal === slideDuration)
        {
          if (itemDuration > slideDuration)
            playHeadVal = 0;
          else
            playHeadVal = slideDuration - itemDuration;
          itemEndTime = slideDuration;
        }
        else
        {
          if ((playHeadVal + itemDuration) > slideDuration)
            itemEndTime = slideDuration;
          else
            itemEndTime = playHeadVal + itemDuration;
        }

        var oldStart = item.enterStart;
        var enterEffectDuration = item.enterEnd - item.enterStart;
        var exitEffectDuration = item.exitEnd - item.exitStart;

        item.enterStart = playHeadVal;
        item.exitEnd = itemEndTime;
        itemDuration = item.exitEnd - item.enterStart;
        if (itemDuration < minDuration)
        {
          itemDuration = minDuration;
          item.enterStart = item.exitEnd - itemDuration;
        }

        if (item.enterEffectName !== "no_Effect")
        {
          if (enterEffectDuration > itemDuration)
          {
            if (enterEffectDuration > minDuration)
            {
              if (itemDuration === minDuration)
                item.enterEnd = itemEndTime;
              else
                item.enterEnd = itemEndTime - minDuration
              enterEffectDuration = item.enterEnd - item.enterStart;
            }
            else
              item.enterEffectName = "no_Effect";
          }
          else
            item.enterEnd = item.enterStart + enterEffectDuration;
        }

        if(item.type === "TEXT"){
          item.textData.formats.containerStyle.margin = '0px';
          let pxRemoval = 30 * state.localStore.get('zoomFactor') ; 
          item.height = item.height - pxRemoval;
          item.width = item.width - pxRemoval;
          item.textData.htmlText = item.textData.htmlText.replace( /(<([^>]+)>)/ig, '');
        }
      
        
        childIds = [];
        if (item.type === "TXTOVLY" || item.type === "GROUP")
        {
          let enterDeviation  = item.enterStart - prevStart;
          let exitDeviation   = item.exitEnd - prevEnd;
          let currentStart = item.enterStart;
          let currentEnd = item.exitEnd;
          for (var x = 0; x < item.groupChildren.length; x++)
          {
            var childId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();

            workspaceChildIds.push(childId);
            let child = workspaceChildren.get(item.groupChildren[x]);
            
            let enterStart = child.get("enterStart") + enterDeviation, exitEnd = child.get("exitEnd") + exitDeviation;
            let chDuration = exitEnd - enterStart;

            if(chDuration < minDuration){
                exitEnd += minDuration * (exitDeviation / (currentEnd - currentStart));
                enterStart -= minDuration * (enterDeviation / (currentEnd - currentStart));
            }
            if(exitEnd <= currentStart){
              enterStart = currentStart;
              exitEnd    = enterStart + minDuration;
            }
            else if(enterStart >= exitEnd){
              enterStart = currentEnd - minDuration;
              exitEnd    = currentEnd;
            }
            else if(exitEnd > currentStart && enterStart < currentStart){
              enterStart = currentStart;
              if(exitEnd - enterStart < minDuration)
                exitEnd = enterStart + minDuration;
            }
            else if(enterStart < currentEnd && exitEnd > currentEnd){
              exitEnd = currentEnd;
              if(exitEnd - enterStart < minDuration)
                enterStart = exitEnd - minDuration;
            }

            let chEntDur = 0, chExtDur = 0, chTimeScale = (exitEnd - enterStart) / (child.get("exitEnd") - child.get("enterStart"));

            if(child.get("enterEffectName") !== "no_Effect" && child.get("enterEnd") > 0)
                chEntDur = child.get("enterEnd") - child.get("enterStart");

            if(child.get("enterEffectName") !== "no_Effect" && child.get("exitStart") > 0)
                chExtDur = child.get("exitEnd") - child.get("exitStart");
            
            if(enterStart + chEntDur > exitEnd - chExtDur){
                chEntDur *= chTimeScale;
                chExtDur *= chTimeScale;
                chEntDur = (chEntDur > 0.1)?chEntDur:0.1;
                chExtDur = (chExtDur > 0.1)?chExtDur:0.1;
            }
           
            child = child.set("enterStart", parseFloat(enterStart.toFixed(1))).set("enterEnd", parseFloat((enterStart + chEntDur).toFixed(1))).set("exitStart", parseFloat((exitEnd - chExtDur).toFixed(1))).set("exitEnd", parseFloat(exitEnd.toFixed(1)));

            
            workspaceChildData.push(child);

            childIds.push(childId)
          }
          
        }


        if (item.type === "TXTOVLY" || item.type === "GROUP")
        {
          item.groupChildren = childIds;
        }

        item.index = nextIndex;
        item.animIndex = nextAnimIndex;
        item.animType = 'On Click';
        uniqueId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();
        
        workspaceIds.push(uniqueId);
        workspaceData.push(item);
      }
      }

      store.dispatch(pasteItemsComplete(selectedScene, workspaceIds, workspaceChildIds, workspaceData, workspaceChildData, action.socket.id, action.socket.id, action.socket));
      action.socket.emit('pasteItems', selectedScene, workspaceIds, workspaceChildIds, workspaceData, workspaceChildData, userId)      
    }
    else if (pasteData.dataType === "SCENES")
    {
      for(var i=0;i<pasteData.data.length;i++){
        const {workspaceCameras,playHeadValue,...actualPasteData}=pasteData.data[i];
          pasteData.data[i]=actualPasteData;
          for (let key in pasteData.data[i]['workspaceItems']) {  
            if(pasteData.data[i]['workspaceItems'][key]['type'] !== 'SCR'){
            if(pasteData.data[i]['workspaceItems'][key]['animType']===undefined){
              pasteData.data[i]['workspaceItems'][key]['animType']='On Click';
               }             
          if (pasteData.data[i]['workspaceItems'].hasOwnProperty(key)) {
            let {isMultimove,exitEffectName,exitStart,exitEnd,keyframes,...actualworkspaceItems}=pasteData.data[i]['workspaceItems'][key];
            pasteData.data[i]['workspaceItems'][key]=actualworkspaceItems;
          }
        }
       }
       }

      let copiedScenes = fromJS(pasteData.data);
      let toPaste = copiedScenes;
      let widthScale = state.project.get("width") / pasteData.width;
      let heightScale = state.project.get("height") / pasteData.height;
      let scale = (widthScale <= heightScale) ? widthScale : heightScale;

      let duration = 0;
      copiedScenes.entrySeq().forEach(([index, scene]) =>
      {
        duration += scene.get("duration");
        let workspaceItems = scene.get("workspaceItems");
        let workspaceChildren = scene.get("workspaceChildren");

        let allItems = fromJS({});
        let allChildren = fromJS({});

        workspaceItems = workspaceItems.mapKeys(k =>
        {
          return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();
        });
       
        i = 0;
        workspaceItems.entrySeq().forEach(([key, value]) =>
        {
          if(workspaceItems.getIn([key,'type']) !== 'SCR')
          {
          workspaceItems = workspaceItems.setIn([key, "animIndex"], i);
          i++;
          }
        });
        workspaceItems.entrySeq().forEach(([itemKey, item]) =>
        {
          if(item.get('type') !== 'SCR'){
            if (item.get("type") === "TEXT")
            {
              let fontSize = item.getIn(["textData", "formats", "containerStyle", "fontSize"]);
              if (fontSize !== undefined)
              {
                item = item.setIn(["textData", "formats", "containerStyle", "fontSize"], (parseFloat(fontSize, 10) * scale) + "px")
              }
                item = item.setIn(["textData", "formats", "containerStyle", "margin"], "0px");
                let pxRemoval = 30 * state.localStore.get('zoomFactor') ; 
                item = item.set('height' - pxRemoval);
                item = item.set('width' - pxRemoval);
                item = item.setIn(['textData','htmlText'],item.getIn(['textData','htmlText']).replace( /(<([^>]+)>)/ig, ''))

            }
            if(item.get('subType') === 'CHR'){
              let urlItems = item.get('thumb').split('/');
              urlItems[1] = item.get('charId');
              let thumbUrl = urlItems.join('/');
              item  = item.set('thumb',thumbUrl+'.png');
            }
          
          let childIds = [];
          if (item.get("type") === "GROUP" || item.get("TXT_OVLY"))
          {
            let itemChildren = workspaceChildren.filter(function (obj, key) { return item.get("groupChildren").indexOf(key) !== -1 });
           
            itemChildren = itemChildren.mapKeys(k => 
            {
              return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();
            });
            itemChildren = itemChildren.sortBy(function (value, key) {return value.get("index");}).toOrderedMap();
            childIds = itemChildren.keySeq().toArray()
            item = item.set("groupChildren", fromJS(childIds));
            if (itemChildren !== undefined && itemChildren.size > 0)
            {
              itemChildren.entrySeq().forEach(([childKey, childItem]) =>
              {
                childItem = childItem.set("width", childItem.get("width") * scale).set("height", childItem.get("height") * scale).set("x", childItem.get("x") * scale).set("y", childItem.get("y") * scale);
                if (childItem.get("type") === "TEXT")
                {
                  let fontSize = childItem.getIn(["textData", "formats", "containerStyle", "fontSize"]);
                  if (fontSize !== undefined)
                  {
                    childItem = childItem.setIn(["textData", "formats", "containerStyle", "fontSize"], (parseFloat(fontSize, 10) * scale) + "px")
                  }
                  childItem = childItem.setIn(["textData", "formats", "containerStyle", "margin"], "0px");
                let pxRemoval = 30 * state.localStore.get('zoomFactor') ; 
                childItem = childItem.set('height' - pxRemoval);
                childItem = childItem.set('width' - pxRemoval);
                childItem = childItem.setIn(['textData','htmlText'],childItem.getIn(['textData','htmlText']).replace( /(<([^>]+)>)/ig, ''))
                  if(childItem.get('subType') === "DTXT"){
                    childItem = childItem.setIn(["textData", "formats", "containerStyle", "lineHeight"],"2.25")
                  }
                }
                allChildren = allChildren.set(childKey, childItem);
              });
            }
          }
         
          allItems = allItems.set(itemKey, item);
        }});

        let bgWidth = scene.getIn(["workspaceBG", "width"]) * pasteData.width, bgHeight = scene.getIn(["workspaceBG", "height"]) * pasteData.height, bgWidthScale = 1, bgHeightScale = 1, oldBgWidth = bgWidth, oldBgHeight = bgHeight;
        if (state.project.get("width") >= state.project.get("height"))
        {
          bgWidth = state.project.get("width");
          bgHeight = oldBgHeight * (bgWidth / oldBgWidth);
          if (bgHeight <= state.project.get("height"))
          {
            bgHeight = state.project.get("height");
            bgWidth = bgWidth * (bgHeight / (oldBgHeight * (bgWidth / oldBgWidth)));
          }
        } 
        else
        {
          bgHeight = state.project.get("height");
          bgWidth = oldBgWidth * (bgHeight / oldBgHeight);
          if (bgWidth <= state.project.get("width"))
          {
            bgWidth = state.project.get("width");
            bgHeight = bgHeight * (bgWidth / (oldBgWidth * (bgHeight / oldBgHeight)));
          }
        }

        bgWidthScale = bgWidth / state.project.get("width");
        bgHeightScale = bgHeight / state.project.get("height");
        
        let dW = state.project.get("width") - bgWidth, dH = state.project.get("height") - bgHeight;
        if(isNaN(dW))
          dW = 0

        if(isNaN(dH))
          dH = 0

        let x = (dW / 2) / state.project.get("width"), y = (dH / 2) / state.project.get("height"), width = bgWidthScale, height = bgHeightScale;
        toPaste = toPaste.setIn([index, "workspaceBG"], scene.get("workspaceBG").merge(fromJS({ x : x, y : y, width : width, height : height})));
        
        toPaste = toPaste.setIn([index, "workspaceItems"], allItems);
        toPaste = toPaste.setIn([index, "workspaceChildren"], allChildren);
        toPaste = toPaste.setIn([index, "id"], Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString());
      });
      store.dispatch(pasteScenesComplete(selectedScene, toPaste.toJS(), action.socket.id, action.socket.id, action.socket));
      action.socket.emit('pasteScenes', selectedScene, toPaste.toJS(), userId)      
    }
  }

  if (action.type === "ADD_BULK_OBJECTS"){
    store.dispatch(addObjComplete(action.data.selectedScene, action.data.workspaceIds, action.data.workspaceData, action.data.workspaceChildIds, action.data.workspaceChildData, action.data.socket.id));
    action.data.socket.emit('addObject', action.data.selectedScene, action.data.workspaceIds, action.data.workspaceData, action.data.workspaceChildIds, action.data.workspaceChildData, userId);    
  }
  if(action.type === 'UPLOAD_BULK_UPDATE'){
    store.dispatch(uploadBulkUpdateComplete(action.data));
    action.socket.emit('uploadBulkUpdate', action.data, userId);    
  }

  if(action.type === 'UPLOAD_BULK_DELETE'){
    store.dispatch(uploadBulkDeleteComplete(action.data));
    action.socket.emit('uploadBulkDelete', action.data, userId);    
  }
 
  if (action.type === "UNDO_MOVE"){
   
    store.dispatch(moveUpdateComplete(action.data.selectedScene, fromJS(action.data.workspaceItems), fromJS(action.data.workspaceChildren), action.data.currentContainer, action.data.socket.id, action.data.socket.id));
    action.data.socket.emit('moveUpdate', action.data.selectedScene, fromJS(action.data.workspaceItems), fromJS(action.data.workspaceChildren), action.data.currentContainer, userId);    
  }

  if(action.type === "UPDATE_TEXT_FORMATS"){
    
    store.dispatch(updateTextComplete(action.data.isGrouped, action.data.selectedScene, action.data.id, action.data.container, action.data.formats, action.data.childIds, action.data.socket.id, action.data.socket.id, true));
    if(action.data.htmlText !== undefined && action.data.htmlText !== ""){
      
      let text = state.project.getIn(["scenes", action.data.selectedScene, action.data.container, action.data.id]);
      text = text.setIn(["textData", "htmlText"], action.data.htmlText);
      
      store.dispatch(changeTextComplete(action.data.selectedScene, action.data.container, action.data.id, text.toJS(), action.data.socket.id, action.data.socket.id, true));
    }
    action.data.socket.emit('updateText', action.data.isGrouped, action.data.selectedScene, action.data.id, action.data.container,  action.data.formats, action.data.childIds, userId);    
  }

  if(action.type === "UPDATE_SLIDE"){
  
    if(action.data.subType === "ADD_SCENE_TRANSITION"){
      store.dispatch(addSceneTransitionComplete(action.data.slideIndex, action.data.value, action.data.sizes, action.data.socket.id, action.data.socket.id));
      action.data.socket.emit('addSceneTransition', action.data.slideIndex, action.data.value, action.data.sizes.toJS(), userId);      
    }
    else if(action.data.subType === "BG_SETTINGS"){
     
      store.dispatch(changeBgComplete(action.data.selectedScene, action.data.value, action.data.deleteId, action.data.deletedData, action.data.socket.id, action.data.socket.id));
      action.data.socket.emit('changeBg', action.data.selectedScene, action.data.value, action.data.deleteId, action.data.deletedData, userId)      
    }
  }

  if(action.type === "UPDATE_OBJECT_BY_ID"){
  
    store.dispatch(updateObjectComplete(projectid, action.data.selectedScene, action.data.id, action.data.container, action.data.toUpdate, action.socket.id, action.socket.id));
    action.socket.emit('updateObject', action.data.selectedScene, action.data.id, action.data.container, action.data.toUpdate, true, userId);    
  }


  if(action.type === "ADD_PREBUILT"){
    var selectedScene = action.data.selectedScene;
    let actualprebuiltData=action.data.prebuilt;
    
    if(action.data.undo !== true){
      if(!action.data.addAll){
        for (let key in actualprebuiltData['workspaceItems']) {
          if (actualprebuiltData['workspaceItems'].hasOwnProperty(key)) {
            let {isMultimove,exitEffectName,exitStart,exitEnd,...workSpaceItems}=actualprebuiltData['workspaceItems'][key]
            actualprebuiltData['workspaceItems'][key] =workSpaceItems;
          }
       }
      }
      else{
        actualprebuiltData['project']['scenes'].forEach((val,idx)=>{
          for (let key in actualprebuiltData['project']['scenes'][idx]['workspaceItems']) {
            if (actualprebuiltData['project']['scenes'][idx]['workspaceItems'].hasOwnProperty(key)) {
              let {isMultimove,exitEffectName,exitStart,exitEnd,...workSpaceItemsForAllScenes}=actualprebuiltData['project']['scenes'][idx]['workspaceItems'][key]
              actualprebuiltData['project']['scenes'][idx]['workspaceItems'][key] =workSpaceItemsForAllScenes;
            }
          }
        })
      }
    }

    let prebuiltData = fromJS(actualprebuiltData);
    if(action.data.undo !== true){
      
      if(!action.data.addAll){
       prebuiltData.getIn(['workspaceItems']).entrySeq().forEach(([key, value])=>{
        if(prebuiltData.getIn(['workspaceItems',key,'textData','formats','containerStyle','margin'])){
          prebuiltData= prebuiltData.setIn(['workspaceItems',key,'textData','formats','containerStyle','margin'],'0px') 
        }
       })
        let allChildren = fromJS({});
        prebuiltData = prebuiltData.set('workspaceItems', prebuiltData.get('workspaceItems').mapKeys(k =>{return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()}));
        prebuiltData.get("workspaceItems").filter(function(obj, key){return obj.get("type") === "GROUP"}).entrySeq().forEach(([ikey, item]) => {
          let newChildren = prebuiltData.get('workspaceChildren').filter(function(obj, key){return item.get("groupChildren").keyOf(key) !== undefined;}).mapKeys(k =>{return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()});
          prebuiltData = prebuiltData.setIn(["workspaceItems", ikey, "groupChildren"], newChildren.keySeq().toList());
          allChildren = allChildren.merge(newChildren);
        })
        prebuiltData = prebuiltData.set('workspaceChildren', OrderedMap(allChildren));
        
        let sortedItems = prebuiltData.get("workspaceItems").sortBy(function (value, key) {
          return value.get("enterStart");
        });
        prebuiltData = prebuiltData.set('workspaceItems', sortedItems);
        // i = 0;
        // prebuiltData.get('workspaceItems').entrySeq().forEach(([key, value]) =>
        // {
        //   prebuiltData=prebuiltData.setIn(['workspaceItems',key,'animType'],'On Click');
        //   prebuiltData= prebuiltData.setIn(['workspaceItems',key, "animIndex"], i);
        //   prebuiltData= prebuiltData.setIn(['workspaceItems',key, "enterStart"], 0);

        //   i++;
        // });
      
        prebuiltData = prebuiltData.setIn(['transEffect'],'NoTransition');
      }else{
        for(let i =0 ; i<prebuiltData.getIn(['project','scenes']).size;i++)
        {
        prebuiltData.getIn(['project','scenes',i,'workspaceItems']).entrySeq().forEach((key,item)=>{
          let wsItem = key[1];
         if(wsItem.get('type')==='TEXT'){
           if(prebuiltData.getIn(['project','scenes',i,'workspaceItems',key[0],'textData','formats','containerStyle','margin']))
          prebuiltData=prebuiltData.setIn(['project','scenes',i,'workspaceItems',key[0],'textData','formats','containerStyle','margin'] ,'0px')
         }
        })
        }
          var prebuiltScenes = prebuiltData.getIn(["project", "scenes"]);
          if(prebuiltScenes.size > 0){
            prebuiltScenes.entrySeq().forEach(([sceneNum, sceneVal]) => {
              let allChildren = fromJS({});
              prebuiltScenes = prebuiltScenes.setIn([sceneNum, "workspaceItems"], sceneVal.get("workspaceItems").mapKeys(k =>{return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()}));
             
              prebuiltScenes.getIn([sceneNum, "workspaceItems"]).filter(function(obj, key){return obj.get("type") === "GROUP"}).entrySeq().forEach(([ikey, item]) => {
                let newChildren = prebuiltScenes.getIn([sceneNum, "workspaceChildren"]).filter(function(obj, key){return item.get("groupChildren").keyOf(key) !== undefined;}).mapKeys(k =>{return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()});
                prebuiltScenes = prebuiltScenes.setIn([sceneNum, "workspaceItems", ikey, "groupChildren"], newChildren.keySeq().toList());
                allChildren = allChildren.merge(newChildren);
              })
              prebuiltScenes = prebuiltScenes.setIn([sceneNum, "workspaceChildren"], OrderedMap(allChildren));

              let sortedItems = prebuiltScenes.getIn([sceneNum, "workspaceItems"]).sortBy(function (value, key) {
                return value.get("enterStart");
              });
              prebuiltScenes = prebuiltScenes.setIn([sceneNum, "workspaceItems"], sortedItems);
              // i=0
              // prebuiltScenes.getIn([sceneNum,'workspaceItems']).entrySeq().forEach(([key, value]) =>
              // {
               
              //   prebuiltScenes=prebuiltScenes.setIn([sceneNum,'workspaceItems',key,'animType'],'On Click');
              //   prebuiltScenes=prebuiltScenes.setIn([sceneNum,'workspaceItems',key,'enterStart'],0);                
              //   prebuiltScenes= prebuiltScenes.setIn([sceneNum,'workspaceItems',key, "animIndex"], i);
              //   i++;
              // });
            });
          }
          

      }
    }
    else{
      for(let i =0 ; i<prebuiltData.getIn(['project','scenes']).size;i++)
        {
        prebuiltData.getIn(['project','scenes',i,'workspaceItems']).entrySeq().forEach((key,item)=>{
          let wsItem = key[1];
         if(wsItem.get('type')==='TEXT'){
           if(prebuiltData.getIn(['project','scenes',i,'workspaceItems',key[0],'textData','formats','containerStyle','margin']))
          prebuiltData=prebuiltData.setIn(['project','scenes',i,'workspaceItems',key[0],'textData','formats','containerStyle','margin'] ,'0px')
         }
        })
        }
          var prebuiltScenes = prebuiltData.getIn(["project", "scenes"]);
          if(prebuiltScenes.size > 0){
            prebuiltScenes.entrySeq().forEach(([sceneNum, sceneVal]) => {
              let allChildren = fromJS({});
              prebuiltScenes = prebuiltScenes.setIn([sceneNum, "workspaceItems"], sceneVal.get("workspaceItems").mapKeys(k =>{return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()}));
             
              prebuiltScenes.getIn([sceneNum, "workspaceItems"]).filter(function(obj, key){return obj.get("type") === "GROUP"}).entrySeq().forEach(([ikey, item]) => {
                let newChildren = prebuiltScenes.getIn([sceneNum, "workspaceChildren"]).filter(function(obj, key){return item.get("groupChildren").keyOf(key) !== undefined;}).mapKeys(k =>{return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()});
                prebuiltScenes = prebuiltScenes.setIn([sceneNum, "workspaceItems", ikey, "groupChildren"], newChildren.keySeq().toList());
                allChildren = allChildren.merge(newChildren);
              })
              prebuiltScenes = prebuiltScenes.setIn([sceneNum, "workspaceChildren"], OrderedMap(allChildren));

              let sortedItems = prebuiltScenes.getIn([sceneNum, "workspaceItems"]).sortBy(function (value, key) {
                return value.get("enterStart");
              });
              prebuiltScenes = prebuiltScenes.setIn([sceneNum, "workspaceItems"], sortedItems);
            });
          }
          prebuiltData = prebuiltData.setIn(["project", "scenes"], prebuiltScenes).setIn(["project", "name"], state.project.get("name"));
          if(action.data.replace !== true){
            var prebuiltScenes = prebuiltScenes.toJS();
            var allScenes = state.project.get("scenes").toJS();
            prebuiltScenes.unshift(selectedScene + 1, 0);
            Array.prototype.splice.apply(allScenes, prebuiltScenes);
            allScenes = fromJS(allScenes);
            prebuiltData = prebuiltData.setIn(["project", "scenes"], allScenes).setIn(["project", "name"], state.project.get("name"));
          }else{
            prebuiltData = prebuiltData.setIn(["project", "scenes"], prebuiltScenes).setIn(["project", "name"], state.project.get("name"));
          }
    }
    prebuiltData = sortGroupEle(prebuiltData, action.data.addAll);
    store.dispatch(addPrebuiltComplete(selectedScene, prebuiltData.toJS(), action.data.replace, action.data.addAll, action.socket.id, action.socket.id));
   
    action.socket.emit("addPrebuilt", selectedScene, prebuiltData.toJS(), action.data.replace, action.data.addAll, userId);    
  }

if(action.type === "UPDATE_BG"){
    store.dispatch(updateBgComplete(projectid, action.data.selectedScene, action.data.toUpdate, action.socket.id, action.socket.id));
    action.socket.emit("updateBg", action.data.selectedScene, action.data.toUpdate, true, userId);    
  }

  if(action.type === "SAVE_PROJECT_NAME"){
   
    store.dispatch(updateProjectComplete(projectid, action.data.toUpdate, action.socket.id, action.socket.id));
    action.socket.emit("updateProject", action.data.toUpdate, userId);    
  }

  if(action.type === "UPDATE_OBJECT"){
   
    store.dispatch(updateObjectComplete(projectid, action.data.selectedScene, action.data.selectedItem, action.data.container, action.data.toUpdate, action.socket.id, action.socket.id));
    action.socket.emit('updateObject', action.data.selectedScene, action.data.selectedItem, action.data.container, action.data.toUpdate, true, userId);    
  }

  if(action.type === "WRITE_TEXT"){
    
    let canEmit = !action.data.isTyping || action.data.undo;
    store.dispatch(updateObjectComplete(projectid, action.data.selectedScene, action.data.selectedItem, action.data.container, action.data.toUpdate, action.socket.id, action.socket.id));
      action.socket.emit('updateObject', action.data.selectedScene, action.data.selectedItem, action.data.container, action.data.toUpdate, true, userId);      
  }

  if(action.type === "SYNC_TEXT") {
    store.dispatch(updateObjectComplete(projectid, action.data.selectedScene, action.data.selectedItem, action.data.container, action.data.toUpdate)); 
  }

  if(action.type === "SET_TEXT_WIDTH"){
    
    let canEmit = !action.data.isTyping || action.data.undo;
    store.dispatch(updateObjectComplete(projectid, action.data.selectedScene, action.data.selectedItem, action.data.container, action.data.toUpdate, action.socket.id, action.socket.id));
      action.socket.emit('updateObject', action.data.selectedScene, action.data.selectedItem, action.data.container, action.data.toUpdate, canEmit, userId);      
  }

  if(action.type === "UPDATE_ITEM"){
    store.dispatch(updateObjectComplete(projectid, action.data.selectedScene, action.data.selectedItem, action.data.container, action.data.toUpdate, action.socket.id, action.socket.id));
    action.socket.emit('updateObject', action.data.selectedScene, action.data.selectedItem, action.data.container, action.data.toUpdate, true, userId);    
  }

  

  if(action.type === "UNDO_SCENE_PASTE"){
    store.dispatch(updateProjectComplete(projectid, action.data.toUpdate, action.socket.id, action.socket.id));
    action.socket.emit("updateProject", action.data.toUpdate, userId);    
  }

  if (action.type === 'APPLY_ENTER_EFFECT')
  {
    store.dispatch(applyEnterEffectComplete( projectid,action.data.selectedScene , action.data.effectData,action.data.isUndo,action.data.sceneEffectData,action.socket.id, action.socket.id));
    action.socket.emit('applyEnterEffect',action.data.selectedScene,action.data.effectData,action.data.isUndo,action.data.sceneEffectData, userId);    
  }
  
  if (action.type === 'APPLY_ALL_TRANSITION')
  {
    store.dispatch(applyAllTransitionComplete( projectid, action.data.transData,action.data.isUndo,action.data.sceneTransData,action.socket.id, action.socket.id ));
    action.socket.emit('applyAllTransition', action.data.transData,action.data.isUndo,action.data.sceneTransData , userId);    
  }

  if(action.type === 'ADD_LINK_TO_TEXT'){
    
    store.dispatch(addLinkToTextComplete(projectid, action.data.selectedScene, action.data.container,action.data.selectedItem, action.data.hyperLinkData, action.socket.id, action.socket.id));
    action.socket.emit('addLinkToText', action.data.selectedScene, action.data.container,action.data.selectedItem, action.data.hyperLinkData, userId);    
  }

  if(action.type === 'ADD_LINK_TO_OBJ'){
    store.dispatch(addLinkToObjComplete(projectid, action.data.selectedScene,action.data.selectedItem, action.data.linkData, action.socket.id, action.socket.id));
    action.socket.emit('addLinkToObj', action.data.selectedScene,action.data.selectedItem, action.data.linkData, userId);    
  }

  if(action.type === 'SET_WORKSPACE_ITEMS_ORDER'){
    store.dispatch(setWorkspaceItemsOrderComplete(projectid,action.data.selectedScene,action.data.container,action.data.workspaceItemsOrder,action.socket.id,action.socket.id));
    action.socket.emit('workspaceItemsOrder',action.data.selectedScene,action.data.container,action.data.workspaceItemsOrder, userId);    
  }
  
  if(action.type === 'SET_ANIMATE_VALUE'){
    store.dispatch(setAnimateValueComplete(projectid,action.data.selectedScene,action.data.container,action.data.selectedItem,action.data.animateData,action.socket.id,action.socket.id));
    action.socket.emit('setAnimateValue',action.data.selectedScene,action.data.container,action.data.selectedItem,action.data.animateData, userId)    
  }

  if (action.type === 'SET_PLAY_ALL') {
    try {
      if (action.data) {

        var projectDataCopy = new OrderedMap(state.project);
        var clonedProjectData = projectDataCopy;
  
        for (let m = 0; m < clonedProjectData.getIn(['scenes']).size; m++) {
          let itemsToLoad = OrderedMap();
          const workspaceItems = clonedProjectData.getIn(['scenes', m, 'workspaceItems']).sortBy(item => item.get('animIndex'));
          const workspaceChildren = clonedProjectData.getIn(['scenes', m, 'workspaceChildren']).sortBy(item => item.get('animIndex'));
          workspaceItems.entrySeq().forEach(([item, workspaceItem]) => {
            if (workspaceItem.get("type") === "GROUP") {
              if(!(workspaceItem.get("enterEffectName") === "no_Effect" && workspaceItem.get('animType') === 'On Load')) {
                itemsToLoad = itemsToLoad.setIn([item], workspaceItem);
                itemsToLoad = itemsToLoad.setIn([item, "isChild"], false);
              }
              else {
                workspaceChildren.entrySeq().forEach(([item, child]) => {
                  if (workspaceItem.getIn(["groupChildren"]).includes(item)) {
                    itemsToLoad = itemsToLoad.setIn([item], child);
                    itemsToLoad = itemsToLoad.setIn([item, "isChild"], true);
                  }
                })
              }
            } else {
              itemsToLoad = itemsToLoad.setIn([item], workspaceItem);
              itemsToLoad = itemsToLoad.setIn([item, "isChild"], false);
            }
          })
          clonedProjectData = clonedProjectData.setIn(['scenes', m, 'workspaceItems'], itemsToLoad);
        }
  
        var itemLabels = {}
        var labelName = 0 ;
        let sceneStartTime = {};
        for (var m = 0; m < clonedProjectData.getIn(['scenes']).size; m++) {
          //to sort the items using key animIndex
          const sortedItems = clonedProjectData.getIn(['scenes', m, 'workspaceItems']).sortBy(item => item.get('animIndex'));
          var currentTime = 0;
          sortedItems.entrySeq().forEach(([key, value]) => {
            itemLabels[key] = {}
            if (value.get("animType") == "On Load")
            {
              itemLabels[key].enterStart = clonedProjectData.getIn(['scenes', m, "startTime"]) + 0;
              itemLabels[key].enterEnd = clonedProjectData.getIn(['scenes', m, "startTime"]) + 0.5;
            }
            else if (value.get("animType") == "On Click") {
              currentTime += 1
              labelName += 1
              itemLabels[key].enterStart = clonedProjectData.getIn(['scenes', m, "startTime"]) + currentTime
              itemLabels[key].enterEnd = currentTime + 0.5
              itemLabels[key].labelName = labelName
            }
            else if (value.get("animType") == "With Previous") {
              itemLabels[key].enterStart = clonedProjectData.getIn(['scenes', m, "startTime"]) + currentTime
              itemLabels[key].enterEnd = currentTime + 0.5
            }
            else if (value.get("animType") == "After Previous") {
              currentTime += 1
              itemLabels[key].enterStart = clonedProjectData.getIn(['scenes', m, "startTime"]) + currentTime + 0.01
              itemLabels[key].enterEnd = currentTime + 0.5
            }
          })
          clonedProjectData = clonedProjectData.setIn(['scenes', m, "duration"], currentTime + 1)
  
          if (m < clonedProjectData.getIn(['scenes']).size - 1) {
            itemLabels["scenetransition" + m] ={}
            itemLabels["scenetransition" + m].enterStart = clonedProjectData.getIn(['scenes', m, "duration"]) + clonedProjectData.getIn(['scenes', m, "startTime"])
            clonedProjectData = clonedProjectData.setIn(['scenes', m + 1, "startTime"], clonedProjectData.getIn(['scenes', m, "duration"]) + clonedProjectData.getIn(['scenes', m, "startTime"]))
          }
          sceneStartTime[m] =clonedProjectData.getIn(['scenes', m, "startTime"]);
        }
        itemLabels['sceneStartTime'] = sceneStartTime;
        store.dispatch(setLabelValues(itemLabels));
      }
    } catch (error) {
      console.log(error);
    }
  }

  if(action.type === 'PROJECT_RESTORE'){
    if(action.data.isEmit)
    action.socket.emit('restoreStart',projectUsr)
  }
  next(action);
};





// WEBPACK FOOTER //
// ./src/autosaveMiddleware.js